// import React, { useCallback, useEffect, useState, useMemo } from 'react';
// import parties from '../data/party';
// import categoriesApi from '../data/categories';
// import stockes from '../data/stockhistory';
// import stockdata from '../data/stock';
// import { fetchStocknames } from '../data/Stocknames';
// import { fetchMutualnames } from '../data/Mutual';
// import Select from "react-select";
// import { useRef } from "react";
// import settingapi from '../data/setting';
// import AsyncSelect from "react-select/async";
// // ...above, in your component function body (not inside useEffect):

// // ... (interfaces/utility types unchanged) ...

// interface Props {}

// interface Party {
//     id: number;
//     date: string;
//     name: string;
//     number: string;
//     contact_person_name: string;
//     contact_person_number: string;
//     categories: string[];
//     deleteparty: number;
//     total_amount?: number | string;
// }

// interface CategoryApiType {
//     id: number | string;
//     category_name: string;
// }

// interface Stock {
//     id: number | string;
//     name: string;
//     category: string;
// }

// type StockCategoryInfo = {
//     id: number | string;
//     stockId: number | string;
//     stockName: string;
//     unit: string;
//     totalAmount: string;
//     indirectCharges: string;
//     perUnitCharge: string;
//     autoCalculated: boolean;
//     category: string;
//     error?: string;
// };
// interface StockNames {
//     id: number;
//     name: string;
//     screener: string;
//     ltp: string;
//     change_percent: string;
//     open_price: string;
//     volume: number;
//     market_cap_cr: string;
//     pe_ratio: string;
//     industry_pe: string;
//     high_52w: string;
//     low_52w: string;
//     returns_1m: string;
//     returns_3m: string;
//     returns_1y: string;
//     returns_3y: string;
//     returns_5y: string;
//     pb_ratio: string;
//     dividend: string;
//     roe: string;
//     roce: string;
//     eps: string;
//     dma_50: string;
//     dma_200: string;
//     rsi: string;
//     margin_funding: string;
//     margin_pledge: string;
//     [key: string]: any;
//   }
// type CategoryEntryMap = { [categoryName: string]: StockCategoryInfo[] };

// type PartyStockDBType = {
//     id: number | string;
//     date:string;
//     party_id: number | string;
//     categories: string | (StockDBCategoryItem | DirectCategoryItem)[];
// };

// type StockDBCategoryItem = {
//     id: number | string;
//     investment_type: string;
//     category: string;
//     stock_name: string;
//     unit: string;
//     total_amount: string;
//     indirect_charges: string;
//     perUnitCharge: string;
// };

// type DirectCategoryItem = {
//     investment_type: string;
//     total_amount: string | number;
//     date?: string;
//     [key: string]: any;
// };
// const safeNumber = (val: any) => {
//     const num = parseFloat(val);
//     return isNaN(num) ? 0 : num;
// };
// let globalEntryId = 1;

// async function fetchStocksAPI() {
//     return [
//         { id: 1, name: 'SBI', category: 'Equity' },
//         { id: 2, name: 'HDFC', category: 'Equity' },
//         { id: 3, name: 'RELIANCE', category: 'Equity' },
//         { id: 4, name: 'NIFTY-FUT', category: 'FNO' },
//         { id: 5, name: 'BANKNIFTY-OPT', category: 'FNO' },
//         { id: 6, name: 'ICICI MF', category: 'Mutual Funds' },
//         { id: 7, name: 'SBI MF', category: 'Mutual Funds' },
//         { id: 8, name: 'NIFTY ETF', category: 'ETF' },
//         { id: 9, name: 'GOLD ETF', category: 'ETF' },
//         { id: 10, name: 'ETF Option A', category: 'ETFO' },
//         { id: 11, name: 'ETF Option B', category: 'ETFO' },
//     ];
// }

// function emptyStockCategoryInfo(category = '', stockId: number | string = '', stockName = ''): StockCategoryInfo {
//     const id = globalEntryId++;
//     return {
//         id,
//         stockId,
//         stockName,
//         category,
//         unit: '',
//         totalAmount: '',
//         indirectCharges: '',
//         perUnitCharge: '',
//         autoCalculated: true,
//         error: undefined
//     };
// }

// function getAvailableUnit(
//     categoryEntries: CategoryEntryMap,
//     category: string,
//     stockId: number | string
// ): number {
//     if (!category || !stockId) return 0;
//     const entries = (categoryEntries[category] || []).filter(
//         entry => entry.stockId == stockId
//     );
//     let total = 0;
//     for (const entry of entries) {
//         const n = parseFloat(entry.unit);
//         if (!isNaN(n)) total += n;
//     }
//     return total;
// }

// // Returns (sum of): category allocations (total_amount+indirect_charges), PLUS direct payments (total_amount where investment_type==='direct') for given party
// function calculateTotalDeductedIncludingDirect(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//     let totalDeducted = 0;
//     stockDbRows.forEach(row => {
//         if (String(row.party_id) !== String(partyId)) return;
//         let catsArr: (StockDBCategoryItem | DirectCategoryItem)[] = [];
//         if (typeof row.categories === 'string') {
//             try {
//                 const parsed = JSON.parse(row.categories);
//                 catsArr = Array.isArray(parsed) ? parsed : [];
//             } catch {
//                 catsArr = [];
//             }
//         } else if (Array.isArray(row.categories)) {
//             catsArr = row.categories as (StockDBCategoryItem | DirectCategoryItem)[];
//         }
//         for (const item of catsArr) {
//             if (
//                 typeof item === "object" &&
//                 (item as any).investment_type === "direct" &&
//                 (item as any).total_amount !== undefined
//             ) {
//                 // Sum up direct investment_type total_amount for deduction
//                 let amt = parseFloat(String((item as any).total_amount) ?? "0");
//                 if (!isNaN(amt)) totalDeducted += amt;
//             } else if (
//                 typeof item === "object" &&
//                 (item as any).category
//             ) {
//                 let amt = parseFloat((item as StockDBCategoryItem).total_amount ?? "0");
//                 let indirect = parseFloat((item as StockDBCategoryItem).indirect_charges ?? "0");
//                 if (!isNaN(amt)) totalDeducted += amt;
//                 if (!isNaN(indirect)) totalDeducted += indirect;
//             }
//         }
//     });
//     return totalDeducted;
// }

// // Only returns sum of (total_amount+indirect_charges) for category allocations, NOT direct payments
// function calculateTotalDeductedFromStockTable(stockDbRows: PartyStockDBType[], partyId: string | number): number {
//     let totalDeducted = 0;
//     stockDbRows.forEach(row => {
//         if (String(row.party_id) !== String(partyId)) return;
//         let catsArr: StockDBCategoryItem[] = [];
//         if (typeof row.categories === 'string') {
//             try {
//                 const parsed = JSON.parse(row.categories);
//                 catsArr = Array.isArray(parsed) ? parsed : [];
//             } catch {
//                 catsArr = [];
//             }
//         } else if (Array.isArray(row.categories)) {
//             catsArr = row.categories as StockDBCategoryItem[];
//         }
//         for (const item of catsArr) {
//             if (typeof item === "object" && 'category' in item) {
//                 let amt = parseFloat(item.total_amount ?? "0");
//                 let indirect = parseFloat(item.indirect_charges ?? "0");
//                 if (!isNaN(amt)) totalDeducted += amt;
//                 if (!isNaN(indirect)) totalDeducted += indirect;
//             }
//         }
//     });
//     return totalDeducted;
// }

// // ---- Sell Stock Modal logic ----

// type SellStockFormState = {
//     partyId: string;
//     category: string;
//     stockId: string | number;
//     stockName: string;
//     sellUnits: string;
//     sellAmount: string;
//     indirectCharges: string;

//     date: string;
// };

// function getStockUnitAndTotalAmount(stocksDbRows: PartyStockDBType[], partyId: string, category: string, stockId: string | number, stockName: string): {totalUnits: number, totalAmount: number} {
//     let totalUnits = 0;
//     let totalAmount = 0;
//     for (const row of stocksDbRows) {
//         if (String(row.party_id) !== String(partyId)) continue;
//         let catsArr: StockDBCategoryItem[] = [];
//         if (typeof row.categories === 'string') {
//             try {
//                 const parsed = JSON.parse(row.categories);
//                 catsArr = Array.isArray(parsed) ? parsed as StockDBCategoryItem[] : [];
//             } catch { catsArr = [] }
//         } else if (Array.isArray(row.categories)) {
//             catsArr = row.categories as StockDBCategoryItem[];
//         }
//         for (const item of catsArr) {
//             if (
//                 item.category === category &&
//                 (String(item.id) === String(stockId) || String(item.stock_name) === String(stockName))
//             ) {
//                 const u = parseFloat(item.unit);
//                 const a = parseFloat(item.total_amount);
//                 if (!isNaN(u)) totalUnits += u;
//                 if (!isNaN(a)) totalAmount += a;
//             }
//         }
//     }
//     return {totalUnits, totalAmount};
// }

// function getAvailableDBStocksForParty(stocksDbRows: PartyStockDBType[], partyId: string) {
//     let out: { [category: string]: StockDBCategoryItem[] } = {};
//     for (const row of stocksDbRows) {
//         if (String(row.party_id) !== String(partyId)) continue;
//         let catsArr: StockDBCategoryItem[] = [];
//         if (typeof row.categories === 'string') {
//             try {
//                 const parsed = JSON.parse(row.categories);
//                 catsArr = Array.isArray(parsed) ? parsed as StockDBCategoryItem[] : [];
//             } catch { catsArr = [] }
//         } else if (Array.isArray(row.categories)) {
//             catsArr = row.categories as StockDBCategoryItem[];
//         }
//         for (const item of catsArr) {
//             if (!out[item.category]) out[item.category] = [];
//             out[item.category].push(item);
//         }
//     }
//     return out;
// }

// function Addstock(props: Props) {
//     // --- existing state and hooks ---
//     const [data, setData] = useState({
//         partyId: '',
//         date: '',
//     });

//     const [investmentType, setInvestmentType] = useState<'direct' | 'structure'>('structure');
//     const [directPaymentAmount, setDirectPaymentAmount] = useState('');
//     const [hasDirectPending, setHasDirectPending] = useState(false);

//     const [categoryEntries, setCategoryEntries] = useState<CategoryEntryMap>({});
//     const [partiesList, setPartiesList] = useState<Party[]>([]);
//     const [allStocks, setAllStocks] = useState<Stock[]>([]);
//     const [categoriesFromApi, setCategoriesFromApi] = useState<CategoryApiType[]>([]);
//     const [possibleStocksByCategory, setPossibleStocksByCategory] = useState<{ [cat: string]: Stock[] }>({});
//     // const [possibleCategories, setPossibleCategories] = useState<CategoryApiType[]>([]);
//     const [stocksDb, setStocksDb] = useState<PartyStockDBType[]>([]);
//     const [stocksDataDb, setStocksDataDb] = useState<PartyStockDBType[]>([]);
//     const [withdrawCategoriesDb, setWithdrawCategoriesDb] = useState<string[]>([]);
//     const [withdrawStocksDb, setWithdrawStocksDb] = useState<StockDBCategoryItem[]>([]);
//     const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
//     const [urlParty, setUrlParty] = useState<string>('');
//     const[totalamountspend, setTotalAmmountSpend] = useState<Number>();

//     const [stocksnames, setStocksnames] = useState<StockNames[]>([]);
//     const [mutualsnames, setMutualsnames] = useState<StockNames[]>([]);
//     useEffect(() => {
//         console.log("mutualsnames count:", mutualsnames.length, "sample:", mutualsnames.slice(0, 3));
//       }, [mutualsnames]);
//     const exceedPromptedRef = useRef(false);
//     const lastCheckedDeductedRef = useRef<number | null>(null);
//     const exceedPromptedOnceRef = useRef(false);
//     const lastDeductedAboveRef = useRef<number | null>(null);
//     const[farmName, setFarmName] = useState<string>();
//     useEffect(() => {
//         async function fetchSettingsApi() {
//           try {
//             const res = await settingapi();
//             if (Array.isArray(res)) {
//               const farmSetting = res.find(
//                 (item: any) => item.meta_key === "farm"
//               );
//               if (farmSetting && farmSetting.meta_value !== undefined) {
//                 let farmObj = {};
//                 try {
//                   farmObj = typeof farmSetting.meta_value === "string"
//                     ? JSON.parse(farmSetting.meta_value)
//                     : farmSetting.meta_value;
//                 } catch {}
//                 if (
//                   farmObj &&
//                   typeof farmObj === "object" &&
//                   farmObj !== null &&
//                   "name" in farmObj &&
//                   typeof (farmObj as { name?: unknown }).name === "string"
//                 ) {
//                   setFarmName((farmObj as { name: string }).name);
//                 }
//               }
//             }
//           } catch {}
//         }
//         fetchSettingsApi();
//       }, []);
//     // URL param logic etc. unchanged
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const partyId = urlParams.get('party') || '';
//         setUrlParty(partyId);
//     }, []);
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const partyId = urlParams.get('party') || '';
//         setUrlParty(partyId);
//         setData(prevData => {
//             if (!prevData.partyId && partyId) {
//                 return { ...prevData, partyId };
//             }
//             return prevData;
//         });
//     }, []);

//     const [withdrawalInvestmentType, setWithdrawalInvestmentType] = useState<'direct' | 'structure'>('structure');
//     const [withdrawalDirectPayment, setWithdrawalDirectPayment] = useState('');

//     const [withdrawal, setWithdrawal] = useState<{
//         partyId: string;
//         category: string;
//         stockId: number | string;
//         stockName: string;
//         sale: string;
//         date: string;
//     }>({
//         partyId: '',
//         category: '',
//         stockId: '',
//         stockName: '',
//         sale: '',
//         date: '',
//     });
//     const [withdrawalLoading, setWithdrawalLoading] = useState(false);

//     const [selectedPartyTotalAmount, setSelectedPartyTotalAmount] = useState<number | null>(null);
//     const [deductedAvailable, setDeductedAvailable] = useState<number | null>(null);

//     const [entryErrors, setEntryErrors] = useState<{ [cat: string]: { [idx: number]: string } }>({});

//     const [directToStructureMeta, setDirectToStructureMeta] = useState<{directPaymentAmount: string, investmentType: "direct", metaDate: string} | null>(null);

//     // ----- MODAL for Sell Stock ----
//     const [showSellStockModal, setShowSellStockModal] = useState(false);
//     const [sellStockLoading, setSellStockLoading] = useState(false);
//     const [sellStockForm, setSellStockForm] = useState<SellStockFormState>({
//         partyId: '',
//         category: '',
//         stockId: '',
//         stockName: '',
//         sellUnits: '',
//         sellAmount:'',
//         indirectCharges:"",
//         date: '',
//     });
//     const [sellStockFormAmount, setSellStockFormAmount] = useState<number>(0);

//     // Fill categories/stocks that are available to the selected party
//     const sellAvailableDBStocks = useMemo(() => getAvailableDBStocksForParty(stocksDataDb, sellStockForm.partyId), [stocksDataDb, sellStockForm.partyId]);
//     const sellPartyCategories = useMemo(
//         () => Object.keys(sellAvailableDBStocks), [sellAvailableDBStocks]
//     );

//     // Stocks in selected category for sellStock modal
//     const sellCategoryStocks = useMemo(() => {
//         if (!sellStockForm.category) return [];
//         return (sellAvailableDBStocks[sellStockForm.category] || []);
//     }, [sellStockForm.category, sellAvailableDBStocks]);
//     const possibleCategories = useMemo(() => {
//         const activePartyId = data.partyId || urlParty;
//         if (!activePartyId || partiesList.length === 0) return [];
//         const selectedParty = partiesList.find(p => String(p.id) === String(activePartyId));
//         // Just show all categories from selectedParty.categories
//         if (selectedParty && Array.isArray(selectedParty.categories) && selectedParty.categories.length > 0) {
//             // Return array of objects: { category_name: ... }
//             return selectedParty.categories.map((name: string) => ({ category_name: name, id: name }));
//         }
//         return [];
//     }, [partiesList, data.partyId, urlParty]);
//     const fetchUserRemainingBalance = useCallback(async (partyId: string) => {
//         if (!partyId) {
//           setTotalAmmountSpend(0);
//           return;
//         }
    
//         try {
//           const usermetaResponse = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`);
//           const usermetaList = await usermetaResponse.json();
          
//           // Find the record where meta_key is "remaining" and party_id matches
//           const foundMeta = usermetaList.find(
//             (meta: any) => meta.meta_key === "remaining" && String(meta.party_id) === String(partyId)
//           );
    
//           if (foundMeta) {
//             setTotalAmmountSpend(Number(foundMeta.meta_value));
//           } else {
//             // Fallback if no meta found: set to 0 or get original total_amount from partiesList
//             const party = partiesList.find(p => String(p.id) === String(partyId));
//             setTotalAmmountSpend(Number(party?.total_amount || 0));
//           }
//         } catch (err) {
//           console.error("Error fetching usermeta:", err);
//           setTotalAmmountSpend(0);
//         }
//       }, [partiesList]);

//       useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const partyId = urlParams.get('party') || '';
//         setUrlParty(partyId);
//         setData(prevData => {
//             if (!prevData.partyId && partyId) {
//                 // Fetch the balance for the URL party ID
//                 fetchUserRemainingBalance(partyId);
//                 return { ...prevData, partyId };
//             }
//             return prevData;
//         });
//     }, [fetchUserRemainingBalance]);

    
//     // Get currently available units and totalAmount for computation
//     const sellStockAvailableDetails = useMemo(() => {
//         if (!sellStockForm.partyId || !sellStockForm.category || !sellStockForm.stockId) {
//             return { unit: 0, amount: 0, current_price: 0 };
//         }
//         // Find matching DB item for party/category/stockId
//         let foundItem = sellCategoryStocks.find(
//             s =>
//                 String(s.id) === String(sellStockForm.stockId)
//                 || String(s.stock_name) === String(sellStockForm.stockName)
//         );
//         if (!foundItem) return { unit: 0, amount: 0, current_price: 0 };

//         let nUnit = parseFloat(foundItem.unit || '0');
//         let nPrice = parseFloat(foundItem.total_amount || '0'); // treating total_amount as current_price here

//         return {
//             unit: !isNaN(nUnit) ? nUnit : 0,
//             amount: !isNaN(nPrice) ? nPrice : 0, // Keeping legacy "amount" for downstream usage
//             current_price: !isNaN(nPrice) ? nPrice : 0,
//             perUnit: !isNaN(nUnit) && nUnit > 0 && !isNaN(nPrice) ? nPrice / nUnit : 0,
//         };
//     }, [sellStockForm.partyId, sellStockForm.category, sellStockForm.stockId, sellStockForm.stockName, sellCategoryStocks]);

//     useEffect(() => {
//         // Compute expected sale amount as soon as sellUnits change
//         let unitsNum = parseFloat(sellStockForm.sellUnits || '0');
//         let {unit, amount} = sellStockAvailableDetails;
//         let perUnit = unit > 0 ? amount / unit : 0;
//         let calc = !isNaN(unitsNum) ? perUnit * unitsNum : 0;
//         setSellStockFormAmount(calc);
//     }, [sellStockForm, sellStockAvailableDetails]);

//     const getNextCategoryId = () => {
//         let allIds: number[] = [];
    
//         stocksDataDb.forEach(row => {
//             const dbItems = typeof row.categories === 'string'
//                 ? JSON.parse(row.categories)
//                 : row.categories;
    
//             dbItems.forEach((item: any) => {
//                 if (item.id) {
//                     allIds.push(Number(item.id));
//                 }
//             });
//         });
    
//         const maxId = allIds.length > 0 ? Math.max(...allIds) : 0;
//         return maxId + 1;
//     };

//     const handleSellStockFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         let patch: Partial<SellStockFormState> = { [name]: value };
//         // Reset following fields on changes:
//         if (name === "partyId") {
//             patch.category = '';
//             patch.stockId = '';
//             patch.stockName = '';
//             patch.sellUnits = '';
//             patch.date = '';
//         }
//         if (name === "category") {
//             patch.stockId = '';
//             patch.stockName = '';
//             patch.sellUnits = '';
//         }
//         if (name === "stockId") {
//             // Find stock name for this stockId
//             const found = sellCategoryStocks.find(s => String(s.id) === value);
//             patch.stockName = found ? found.stock_name : '';
//         }
//         setSellStockForm(s => ({ ...s, ...patch }));
//     };

//     // Modal submit logic
//     const handleSellStockSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();
//         if (!sellStockForm.partyId) {
//             alert('Select party');
//             return;
//         }
//         if (!sellStockForm.category) {
//             alert('Select category');
//             return;
//         }
//         if (!sellStockForm.stockId) {
//             alert('Select stock');
//             return;
//         }
//         let sellUnitsNumber = parseFloat(sellStockForm.sellUnits || '0');
//         if (!sellStockForm.sellUnits || isNaN(sellUnitsNumber) || sellUnitsNumber <= 0) {
//             alert('Please enter valid units to sell');
//             return;
//         }
//         if (sellUnitsNumber > sellStockAvailableDetails.unit) {
//             alert(
//                 `Not enough units available to sell! Available: ${sellStockAvailableDetails.unit}, Requested: ${sellUnitsNumber}`
//             );
//             return;
//         }
//         if (!sellStockForm.date) {
//             alert("Select date for sell");
//             return;
//         }

//         // Calculate amount
//         const expectedAmount = sellStockFormAmount;

//         // Compose API request (implementation specific!)
//         setSellStockLoading(true);
//         try {
//             // This should be replaced with your real API endpoint.
//             const payload = {
//                 party_id: sellStockForm.partyId ?? null,
//                 category: sellStockForm.category ?? null,
//                 stock_id: sellStockForm.stockId ?? null,
//                 stock_name: sellStockForm.stockName ?? null,
//                 sell_units: sellUnitsNumber ?? null,
//                 sell_amount: expectedAmount ?? null,
//                 indirect_charges: sellStockForm.indirectCharges ?? null,
//                 date: sellStockForm.date ?? null
//             };
//             const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(payload),
//             });
//             const result = await res.json();
//             if (!res.ok) throw new Error(result?.message || 'Failed to sell stock');
//             alert('Stock sell recorded successfully!');
//             setShowSellStockModal(false);
//             setSellStockForm({
//                 partyId: '',
//                 category: '',
//                 stockId: '',
//                 stockName: '',
//                 sellUnits: '',
//                 sellAmount:"",
//                 indirectCharges:"",
//                 date: '',
//             });
//             // Refresh the page or fetch state as necessary
//             window.location.reload();
//         } catch (err: any) {
//             alert('Error: ' + (err?.message ?? 'Something went wrong'));
//         } finally {
//             setSellStockLoading(false);
//         }
//     };

//     // End --- MODAL for sell stock ----

//     const fetchParties = useCallback(async () => {
//         const res = await parties();
//         const cleaned = Array.isArray(res)
//             ? res.map((item: any) => ({
//                 ...item,
//                 categories:
//                     typeof item.categories === 'string'
//                         ? (() => {
//                             try {
//                                 const parsed = JSON.parse(item.categories);
//                                 return Array.isArray(parsed) ? parsed : [item.categories];
//                             } catch {
//                                 return [item.categories];
//                             }
//                         })()
//                         : Array.isArray(item.categories)
//                             ? item.categories
//                             : [],
//                 total_amount: item.total_amount !== undefined ? Number(item.total_amount) : undefined,
//             }))
//             : [];
//         setPartiesList(cleaned);
//     }, []);
//     const fetchStocksNames = async () => {
        
//         try {
//           const res = await fetchStocknames();
         
//           const data = await res;
//           setStocksnames(Array.isArray(data) ? data : []);
//         } catch (err: any) {
//             setStocksnames([]);
//         } finally {
          
//         }
//       };
//     const fetchMutualNames = async () => {
        
//         try {
//           const res = await fetchMutualnames();
         
//           const data = await res;
//           setMutualsnames(Array.isArray(data) ? data : []);
//         } catch (err: any) {
//             setMutualsnames([]);
//         } finally {
          
//         }
//       };
    
//     const fetchCategories = useCallback(async () => {
//         const res = await categoriesApi();
//         if (Array.isArray(res)) {
//             setCategoriesFromApi(res);
//             console.log("categoriesFromApi:", res);
//             // setPossibleCategories(res);
//         }
//     }, []);

//     const fetchAllStocksForCategories = useCallback(async () => {
//         const stocks: Stock[] = await fetchStocksAPI();
//         setAllStocks(stocks);

//         const byCategory: { [cat: string]: Stock[] } = {};
//         stocks.forEach(stock => {
//             if (!byCategory[stock.category]) byCategory[stock.category] = [];
//             byCategory[stock.category].push(stock);
//         });
//         setPossibleStocksByCategory(byCategory);
//     }, []);

//     const fetchStocksDb = useCallback(async () => {
//         try {
//             const res = await stockes();
//             setStocksDb(Array.isArray(res) ? res : []);
//         } catch (e) {
//             setStocksDb([]);
//         }
//     }, []);

//     const fetchStocksDataDb = useCallback(async () => {
//         try {
//             const res = await stockdata();
//             setStocksDataDb(Array.isArray(res) ? res : []);
//         } catch (e) {
//             setStocksDataDb([]);
//         }
//     }, []);

//     useEffect(() => {
//         fetchStocksNames();
//         fetchMutualNames();
//         fetchParties();
//         fetchCategories();
//         fetchAllStocksForCategories();
//         fetchStocksDb();
//         fetchStocksDataDb();
//     }, [fetchParties, fetchCategories, fetchAllStocksForCategories, fetchStocksDb, fetchStocksDataDb]);

//     useEffect(() => {
//         if (categoriesFromApi.length === 0) return;
    
//         const activePartyId = data.partyId || urlParty;
//         if (!activePartyId || partiesList.length === 0) return;
    
//         const selectedParty = partiesList.find(p => String(p.id) === String(activePartyId));
//         if (selectedParty && Array.isArray(selectedParty.categories) && selectedParty.categories.length > 0) {
//             const filtered = categoriesFromApi.filter(cat =>
//                 (selectedParty.categories as string[]).includes(cat.category_name)
//             );
//             // setPossibleCategories(filtered.length > 0 ? filtered : categoriesFromApi);
//         } else {
//             // setPossibleCategories(categoriesFromApi);
//         }
//     }, [categoriesFromApi, partiesList, data.partyId, urlParty]);
//     useEffect(() => {
//         if (data.partyId && partiesList.length > 0) {
//             const party = partiesList.find(p => String(p.id) === String(data.partyId));
//             if (party && party.total_amount !== undefined && party.total_amount !== null && !isNaN(Number(party.total_amount))) {
//                 setSelectedPartyTotalAmount(Number(party.total_amount));
//             } else {
//                 setSelectedPartyTotalAmount(null);
//             }
//         } else {
//             setSelectedPartyTotalAmount(null);
//         }
//     }, [data.partyId, partiesList]);

//     // !! The available amount (after deduction) considers both direct payments and structure/indirect charges
//     useEffect(() => {
//         if (!selectedPartyTotalAmount) {
//             setDeductedAvailable(null);
//             return;
//         }

//         if (!data.partyId || !stocksDataDb.length) {
//             setDeductedAvailable(selectedPartyTotalAmount);
//             return;
//         }

//         // 1. Get total deducted amount up to now (from stockdata) including direct amounts
//         const dbDeducted = calculateTotalDeductedIncludingDirect(stocksDataDb, data.partyId);

//         let newDeducted = selectedPartyTotalAmount - dbDeducted;
//         let overage = 0;

//         if (investmentType === "direct") {
//             if (directPaymentAmount && !isNaN(Number(directPaymentAmount))) {
//                 newDeducted -= Number(directPaymentAmount);
//             }
//             overage = -newDeducted;
//             setDeductedAvailable(newDeducted);
//         } else if (investmentType === "structure") {
//             // sum of new entries (totalAmount + indirectCharges)
//             let uiDeducted = 0;
//             Object.entries(categoryEntries).forEach(([category, ents]) => {
//                 ents.forEach(ent => {
//                     let amt = parseFloat(ent.totalAmount || "0");
//                     if (isNaN(amt)) amt = 0;
//                     let indirect = parseFloat(ent.indirectCharges || "0");
//                     if (isNaN(indirect)) indirect = 0;
//                     uiDeducted += amt + indirect;
//                 });
//             });
//             // support direct-to-structure transition: add pending direct (if any)
//             let pendingDirect = directToStructureMeta ? Number(directToStructureMeta.directPaymentAmount) || 0 : 0;
//             newDeducted = selectedPartyTotalAmount - dbDeducted - uiDeducted - pendingDirect;
//             overage = -newDeducted;
//             setDeductedAvailable(newDeducted);
//         }

//         // Only prompt user if overage (amount exceeds available), only once per session
//         // If press Cancel, don't let them add: block by setting a marker and a disable flag
//         if (
//             newDeducted < 0 &&
//             !exceedPromptedRef.current // Use ref to avoid repeated asks
//         ) {
//             setTimeout(() => {
//                 // eslint-disable-next-line no-alert
//                 const confirm = window.confirm(" You exceed your amount. Do you want to add it from margin money?");
//                 if (confirm) {
//                     exceedPromptedRef.current = true; // User allows, do not prompt anymore
//                 } else {
//                     exceedPromptedRef.current = true; // Prevent further prompts
//                     // Block adding: setDeductedAvailable to null to disable actions
//                     setDeductedAvailable(null);
//                 }
//             }, 100); // Slight timeout to ensure UI is updated
//         }

//     }, [
//         selectedPartyTotalAmount,
//         investmentType,
//         directPaymentAmount,
//         categoryEntries,
//         data.partyId,
//         stocksDataDb,
//         directToStructureMeta
//     ]);

//     useEffect(() => {
//         if (investmentType === "direct") setHasDirectPending(false);
//         if (investmentType === "structure" && directToStructureMeta) setHasDirectPending(true);
//     }, [investmentType, directToStructureMeta]);

//     // --- REMOVE restriction: allow any allocation, only show "not enough" but don't block
//     useEffect(() => {
//         // No error/disable logic anymore
//         setEntryErrors({});
//     }, [categoryEntries, stocksDataDb, data.partyId, selectedPartyTotalAmount, investmentType, directToStructureMeta]);

//     const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         setData(prev => ({
//             ...prev,
//             [name]: value,
//         }));
//         if (name === "partyId") {
//             setInvestmentType('structure');
//             setCategoryEntries({});
//             setDirectPaymentAmount('');
//             setDirectToStructureMeta(null);
//             fetchUserRemainingBalance(value);
        
//             if (value) {
//                 const selectedParty = partiesList.find(p => String(p.id) === String(value));
//                 if (selectedParty && Array.isArray(selectedParty.categories) && selectedParty.categories.length > 0) {
//                     // categories is already a parsed array thanks to fetchParties cleanup
//                     const filtered = categoriesFromApi.filter(cat =>
//                         (selectedParty.categories as string[]).includes(cat.category_name)
//                     );
//                     // setPossibleCategories(filtered.length > 0 ? filtered : categoriesFromApi);
//                 } else {
//                     // setPossibleCategories(categoriesFromApi);
//                 }
//             } else {
//                 // setPossibleCategories([]);
//             }
//         }
//         if (name === "directPaymentAmount") {
//             setDirectPaymentAmount(value);
//         }
//     };

//     const handleInvestmentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const value = e.target.value as 'direct' | 'structure';
//         setInvestmentType(value);
//         setDirectPaymentAmount('');
//         setCategoryEntries({});
//         setDirectToStructureMeta(null);
//         setHasDirectPending(false);
//     };

//     const isChecked = (cat: CategoryApiType) => Object.prototype.hasOwnProperty.call(categoryEntries, cat.category_name);

//     const handleCategory = (cat: CategoryApiType) => {
//         const category = cat.category_name;
//         setCategoryEntries(prev => {
//             const copy = { ...prev };
//             if (copy[category]) {
//                 delete copy[category];
//             } else {
//                 copy[category] = [
//                     emptyStockCategoryInfo(
//                         category,
//                         '',
//                         ''
//                     ),
//                 ];
//             }
//             return copy;
//         });
//     };

//     const handleCategoryFieldChange = (
//         cat: CategoryApiType,
//         entryIdx: number,
//         field: keyof StockCategoryInfo,
//         value: string
//     ) => {
//         const category = cat.category_name;
//         setCategoryEntries(prev => {
//             const entries = prev[category] ? [...prev[category]] : [];
//             const entry = entries[entryIdx] ? { ...entries[entryIdx] } : emptyStockCategoryInfo(category);

//             let autoCalculated = entry.autoCalculated;
//             let newPerUnitCharge = entry.perUnitCharge;

//             let total = field === "totalAmount" ? value : entry.totalAmount || "0";
//             let indirect = field === "indirectCharges" ? value : entry.indirectCharges || "0";
//             let unit = field === "unit" ? value : entry.unit || "0";

//             let newEntry = { ...entry };

//             if (field === 'stockName') {
//                 newEntry.stockName = value;

//                 if (value && value.trim()) {
//                     const stock = allStocks.find(
//                         s => s.category === category && (
//                             String(s.name).toLowerCase() === String(value).toLowerCase() ||
//                             String(s.id) === String(value)
//                         )
//                     );
//                     if (stock) {
//                         newEntry.stockId = stock.id;
//                     } else {
//                         newEntry.stockId = value;
//                     }
//                 } else {
//                     newEntry.stockId = '';
//                 }
//             } else if (field === 'stockId') {
//                 newEntry.stockId = value;
//                 if (value && value.trim()) {
//                     const stock = allStocks.find(
//                         s => s.category === category && (
//                             String(s.id) === String(value) ||
//                             String(s.name).toLowerCase() === String(value).toLowerCase()
//                         )
//                     );
//                     newEntry.stockName = stock ? stock.name : value;
//                 } else {
//                     newEntry.stockName = '';
//                 }
//             }

//             // Fix: Allow perUnitCharge zero for ETF/ETFO category, otherwise as before.
//             if (field === "unit" || field === "totalAmount" || field === "indirectCharges") {
//                 const unitN = parseFloat(unit);
//                 const totalAmountN = parseFloat(total || "0");
//                 const indirectChargesN = parseFloat(indirect || "0");
//                 if (unitN > 0) {
//                     newPerUnitCharge = ((totalAmountN + indirectChargesN) / unitN).toFixed(2);
//                     autoCalculated = true;
//                 } else {
//                     newPerUnitCharge = '';
//                     autoCalculated = true;
//                 }
//                 newEntry[field] = value;
//                 newEntry.perUnitCharge = newPerUnitCharge;
//                 newEntry.autoCalculated = autoCalculated;
//             } else if (field === "perUnitCharge") {
//                 autoCalculated = false;
//                 newPerUnitCharge = value;
//                 newEntry.perUnitCharge = value;
//                 newEntry.autoCalculated = false;
//             } else if (field !== "stockId" && field !== "stockName") {
//                 (newEntry as any)[field] = value;
//             }

//             entries[entryIdx] = newEntry;
//             return { ...prev, [category]: entries };
//         });
//     };

//     const handleAddEntry = (cat: CategoryApiType) => {
//         const category = cat.category_name;
//         setCategoryEntries(prev => {
//             const entries = prev[category] ? [...prev[category]] : [];
//             return {
//                 ...prev,
//                 [category]: [
//                     ...entries,
//                     emptyStockCategoryInfo(
//                         category,
//                         '',
//                         ''
//                     ),
//                 ],
//             };
//         });
//     };

//     const handleRemoveEntry = (cat: CategoryApiType, entryIdx: number) => {
//         const category = cat.category_name;
//         setCategoryEntries(prev => {
//             const entries = prev[category] ? [...prev[category]] : [];
//             entries.splice(entryIdx, 1);
//             const newEntries = entries.length === 0 ? undefined : entries;
//             const copy: CategoryEntryMap = { ...prev };
//             if (newEntries && newEntries.length > 0) {
//                 copy[category] = newEntries;
//             } else {
//                 delete copy[category];
//             }
//             return copy;
//         });
//     };

//     // ---- SUBMIT ---- (unchanged except removal of restriction)
//     const handleSubmit2 = async (e?: React.FormEvent) => {
//         if (e) e.preventDefault();
//         if (!data.partyId) {
//             alert('Please select a party');
//             return;
//         }
    
//         let party: Party | undefined = partiesList.find(p => String(p.id) === String(data.partyId));
//         let availableTotalAmount = (party && party.total_amount !== undefined) ? Number(party.total_amount) : null;
//         if (availableTotalAmount == null) {
//             alert("Could not determine total amount available.");
//             return;
//         }
    
//         const isStructure = investmentType === 'structure';
//         const selectedCategories = Object.keys(categoryEntries);
//         if (selectedCategories.length === 0) {
//             alert('Please select at least one category');
//             return;
//         }
    
//         // Array to hold ONLY completely new stocks for the POST method
//         let categoriesToSubmitForPost: any[] = [];
    
//         for (const categoryName of selectedCategories) {
//             const entries = categoryEntries[categoryName];
    
//             for (const [idx, catInfo] of entries.entries()) {
//                 if (!catInfo.stockName || !catInfo.stockName.trim()) continue;
    
//                 // 1. Search for this stock in the current database state
//                 const existingRow = stocksDataDb.find(row => {
//                     if (String(row.party_id) !== String(data.partyId)) return false;
//                     let dbItems: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//                     return dbItems.some(item => item.stock_name === catInfo.stockName && item.category === categoryName);
//                 });
    
//                 if (existingRow) {
//                     // 2. STOCK EXISTS -> CALCULATE AND EXECUTE PUT IMMEDIATELY
//                     let dbItems: any[] = typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : existingRow.categories;
//                     let item = dbItems.find(i => i.stock_name === catInfo.stockName && i.category === categoryName);
    
//                     const oldUnit = parseFloat(item.unit || "0");
//                     const oldAmount = parseFloat(item.total_amount || "0");
//                     const oldIndirect = parseFloat(item.indirect_charges || "0");
    
//                     const newUnit = parseFloat(catInfo.unit || "0");
//                     const newAmount = parseFloat(catInfo.totalAmount || "0");
//                     const newIndirect = parseFloat(catInfo.indirectCharges || "0");
    
//                     const totalUnit = oldUnit + newUnit;
//                     const totalAmount = oldAmount + newAmount;
//                     const totalIndirect = oldIndirect + newIndirect;
                    
//                     // Recalculate average price per unit including indirect charges
//                     const avgPricePerUnit = totalUnit > 0 ? ((totalAmount + totalIndirect) / totalUnit).toFixed(2) : "0.00";
    
//                     const putBody = {
//                         id: existingRow.id,                // The database row ID
//                         cat_id: catInfo.id,               // The entry ID from the UI
//                         name: catInfo.stockName,
//                         party_id: data.partyId,
//                         categories: JSON.stringify([{     // Updated categories array for the backend
//                             ...item,
//                             unit: totalUnit.toString(),
//                             total_amount: totalAmount.toString(),
//                             indirect_charges: totalIndirect.toString(),
//                             perUnitCharge: avgPricePerUnit,
//                             total_amount_category: totalAmount.toString()
//                         }]),
//                         category: categoryName,
//                         unit: totalUnit.toString(),
//                         price_per_unit: avgPricePerUnit,
//                         total_amount: totalAmount.toString(),
//                         indirect_charges: totalIndirect.toString(),
//                         date: data.date || existingRow.date
//                     };
    
//                     try {
//                         // Note: URL includes the ID as you requested earlier
//                         const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                             method: 'PUT',
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify(putBody),
//                         });
//                         if (!res.ok) throw new Error(`Failed to update existing stock: ${catInfo.stockName}`);
//                         // console.log(`Updated ${catInfo.stockName} via PUT`);
//                     } catch (err) {
//                         console.error("PUT Error:", err);
//                     }
    
//                 } else {
//                     // 3. STOCK DOES NOT EXIST -> COLLECT FOR POST
//                     categoriesToSubmitForPost.push({
//                         id: catInfo.id,
//                         stock_name: catInfo.stockName,
//                         unit: catInfo.unit,
//                         total_amount: catInfo.totalAmount,
//                         indirect_charges: catInfo.indirectCharges ?? "0",
//                         perUnitCharge: catInfo.perUnitCharge,
//                         category: categoryName,
//                         investment_type: isStructure ? "structure" : "direct",
//                         total_amount_category: catInfo.totalAmount
//                     });
//                 }
//             }
//         }
    
//         // 4. Final Step: Only fire POST if there are actual NEW stocks
//         if (categoriesToSubmitForPost.length > 0) {
//             const postPayload = {
//                 party_id: data.partyId,
//                 date: data.date,
//                 investment_type: isStructure ? 'structure' : 'direct',
//                 categories: categoriesToSubmitForPost
//             };
    
//             try {
//                 const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(postPayload),
//                 });
//                 if (!res.ok) throw new Error('Failed to create new stocks via POST');
//                 // console.log("Created new stocks via POST");
//             } catch (err: any) {
//                 alert(err.message);
//             }
//         }
    
//         alert('Submission process finished');
//         window.location.reload();
//     };
//     const handleSubmitold = async (e?: React.FormEvent) => {
//         if (e) e.preventDefault();
        
//         // 1. Initial Validation
//         if (!data.partyId) {
//             alert('Please select a party');
//             return;
//         }

//         let party: Party | undefined = partiesList.find(p => String(p.id) === String(data.partyId));
//         let availableTotalAmount = (party && party.total_amount !== undefined) ? Number(party.total_amount) : null;
        
//         if (availableTotalAmount == null) {
//             alert("Could not determine total amount available for the selected party.");
//             return;
//         }

//         const selectedCategories = Object.keys(categoryEntries);
//         if (selectedCategories.length === 0) {
//             alert('Please select at least one category');
//             return;
//         }

//         // ==========================================
//         // CASE A: DIRECT PAYMENT LOGIC
//         // ==========================================
//         if (investmentType === 'direct' && !hasDirectPending) {
//             if (!directPaymentAmount || isNaN(Number(directPaymentAmount)) || Number(directPaymentAmount) <= 0) {
//                 alert('Please enter a valid payment amount');
//                 return;
//             }

//             for (const categoryName of selectedCategories) {
//                 // Check if a Direct Payment record already exists for this party/category
//                 const existingDirectRow = stocksDataDb.find(row => {
//                     if (String(row.party_id) !== String(data.partyId)) return false;
//                     let dbItems = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//                     return dbItems.some((item:any) => item.investment_type === "direct" && item.category === categoryName);
//                 });

//                 if (existingDirectRow) {
//                     // UPDATE EXISTING DIRECT RECORD (PUT)
//                     let dbItems = typeof existingDirectRow.categories === 'string' ? JSON.parse(existingDirectRow.categories) : existingDirectRow.categories;
//                     let item = dbItems.find((i:any) => i.investment_type === "direct" && i.category === categoryName);

//                     const oldAmount = parseFloat(item.total_amount || "0");
//                     const newAmount = parseFloat(directPaymentAmount);
//                     const totalAmt = (oldAmount + newAmount).toString();

//                     const putBody = {
//                         id: existingDirectRow.id,
//                         cat_id: item.id || '',
//                         name: "Direct Payment",
//                         party_id: data.partyId,
//                         categories: JSON.stringify([{
//                             ...item,
//                             total_amount: totalAmt,
//                             total_amount_category: totalAmt,
//                             investment_type: "direct"
//                         }]),
//                         category: categoryName,
//                         unit: "0",
//                         price_per_unit: "0",
//                         total_amount: totalAmt,
//                         indirect_charges: "0",
//                         date: data.date || existingDirectRow.date
//                     };

//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                         method: 'PUT',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(putBody),
//                     });
//                 } else {
//                     // CREATE NEW DIRECT RECORD (POST)
//                     const postPayload = {
//                         party_id: data.partyId,
//                         date: data.date ?? null,
//                         investment_type: "direct",
//                         direct_payment_amount: directPaymentAmount,
//                         categories: [{
//                             investment_type: "direct",
//                             total_amount: Number(directPaymentAmount),
//                             category: categoryName,
//                             total_amount_category: directPaymentAmount
//                         }]
//                     };
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(postPayload),
//                     });
//                 }
//             }
//             alert('Direct Payment processed');
//             window.location.reload();
//             return;
//         }

//         // ==========================================
//         // CASE B: STRUCTURE PAYMENT LOGIC (STOCKS)
//         // ==========================================
//         let categoriesToSubmitForPost: any[] = [];
//         const isStructure = investmentType === 'structure';

//         for (const categoryName of selectedCategories) {
//             const entries = categoryEntries[categoryName];

//             for (const [idx, catInfo] of entries.entries()) {
//                 if (!catInfo.stockName || !catInfo.stockName.trim()) continue;

//                 // Find if stock already exists in DB
//                 const existingStockRow = stocksDataDb.find(row => {
//                     if (String(row.party_id) !== String(data.partyId)) return false;
//                     let dbItems = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//                     return dbItems.some((item:any) => item.stock_name === catInfo.stockName && item.category === categoryName);
//                 });

//                 if (existingStockRow) {
//                     // UPDATE EXISTING STOCK (PUT)
//                     let dbItems = typeof existingStockRow.categories === 'string' ? JSON.parse(existingStockRow.categories) : existingStockRow.categories;
//                     let item = dbItems.find((i:any) => i.stock_name === catInfo.stockName && i.category === categoryName);

//                     const oldUnit = parseFloat(item.unit || "0");
//                     const oldAmt = parseFloat(item.total_amount || "0");
//                     const oldInd = parseFloat(item.indirect_charges || "0");

//                     const newUnit = parseFloat(catInfo.unit || "0");
//                     const newAmt = parseFloat(catInfo.totalAmount || "0");
//                     const newInd = parseFloat(catInfo.indirectCharges || "0");

//                     const totalU = oldUnit + newUnit;
//                     const totalA = oldAmt + newAmt;
//                     const totalI = oldInd + newInd;
//                     const avgPrice = totalU > 0 ? ((totalA + totalI) / totalU).toFixed(2) : "0.00";

//                     const putBody = {
//                         id: existingStockRow.id,
//                         cat_id: catInfo.id,
//                         name: catInfo.stockName,
//                         party_id: data.partyId,
//                         categories: JSON.stringify([{
//                             ...item,
//                             unit: totalU.toString(),
//                             total_amount: totalA.toString(),
//                             indirect_charges: totalI.toString(),
//                             perUnitCharge: avgPrice,
//                             total_amount_category: totalA.toString()
//                         }]),
//                         category: categoryName,
//                         unit: totalU.toString(),
//                         price_per_unit: avgPrice,
//                         total_amount: totalA.toString(),
//                         indirect_charges: totalI.toString(),
//                         date: data.date || existingStockRow.date
//                     };

//                     try {
//                         const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                             method: 'PUT',
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify(putBody),
//                         });
//                         if (!res.ok) throw new Error(`Update failed for ${catInfo.stockName}`);
//                     } catch (err) { console.error(err); }

//                 } else {
//                     // NEW STOCK (COLLECT FOR POST)
//                     categoriesToSubmitForPost.push({
//                         id: catInfo.id,
//                         stock_name: catInfo.stockName,
//                         unit: catInfo.unit,
//                         total_amount: catInfo.totalAmount,
//                         indirect_charges: catInfo.indirectCharges ?? "0",
//                         perUnitCharge: catInfo.perUnitCharge,
//                         category: categoryName,
//                         investment_type: isStructure ? "structure" : "direct",
//                         total_amount_category: catInfo.totalAmount
//                     });
//                 }
//             }
//         }

//         // Final POST call for all completely new items
//         if (categoriesToSubmitForPost.length > 0) {
//             const finalPayload = {
//                 party_id: data.partyId,
//                 date: (hasDirectPending && directToStructureMeta) ? directToStructureMeta.metaDate : data.date,
//                 investment_type: isStructure ? 'structure' : 'direct',
//                 categories: categoriesToSubmitForPost
//             };
//             // if (hasDirectPending && directToStructureMeta) finalPayload.direct_payment_amount = directToStructureMeta.directPaymentAmount;

//             try {
//                 const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(finalPayload),
//                 });
//                 if (!res.ok) throw new Error('Post failed');
//             } catch (err: any) { alert(err.message); }
//         }

//         alert('Process completed successfully');
//         window.location.reload();
//     };
//     const handleSubmitworkingwell = async (e?: React.FormEvent) => {
//         if (e) e.preventDefault();
//         if (!data.partyId) {
//             alert('Please select a party');
//             return;
//         }

//         let party: Party | undefined = partiesList.find(p => String(p.id) === String(data.partyId));
//         let availableTotalAmount = (party && party.total_amount !== undefined) ? Number(party.total_amount) : null;
//         if (availableTotalAmount == null) {
//             alert("Could not determine total amount available.");
//             return;
//         }

//         const isStructure = investmentType === 'structure';
//         const selectedCategories = Object.keys(categoryEntries);
//         if (selectedCategories.length === 0) {
//             alert('Please select at least one category');
//             return;
//         }

//         // Map to group updates by Row ID to prevent overwriting when updating multiple stocks in one row
//         const rowUpdates = new Map();
//         let categoriesToSubmitForPost: any[] = [];

//         // Track the sum of all total_amounts being added/updated
//         let grandTotalAmount = 0;

//         for (const categoryName of selectedCategories) {
//             const entries = categoryEntries[categoryName];

//             for (const catInfo of entries) {
//                 if (!catInfo.stockName || !catInfo.stockName.trim()) continue;

//                 // Grab this stock's total_amount for summing, if defined
//                 const currentTotalAmount = parseFloat(catInfo.totalAmount || "0");
//                 if (!isNaN(currentTotalAmount)) {
//                     grandTotalAmount += currentTotalAmount;
//                 }
//                 const currentIndirectCharges = parseFloat(catInfo.indirectCharges || "0");
//                 if (!isNaN(currentIndirectCharges)) {
//                     grandTotalAmount += currentIndirectCharges;
//                 }

//                 // 1. Find the existing row in the DB
//                 const existingRow = stocksDataDb.find(row => {
//                     if (String(row.party_id) !== String(data.partyId)) return false;
//                     let dbItems: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//                     return dbItems.some(item => item.stock_name === catInfo.stockName && item.category === categoryName);
//                 });

//                 if (existingRow) {
//                     // 2. Get the current state of this row's array (either from our local map or the DB)
//                     let currentArray = rowUpdates.has(existingRow.id)
//                         ? rowUpdates.get(existingRow.id).updatedCategories
//                         : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories]);

//                     let targetStock = currentArray.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);

//                     if (targetStock) {
//                         // --- CALCULATE UPDATED VALUES ---
//                         const oldUnit = parseFloat(targetStock.unit || "0");
//                         const oldAmount = parseFloat(targetStock.total_amount || "0");
//                         const oldIndirect = parseFloat(targetStock.indirect_charges || "0");

//                         const newUnit = parseFloat(catInfo.unit || "0");
//                         const newAmount = parseFloat(catInfo.totalAmount || "0");
//                         const newIndirect = parseFloat(catInfo.indirectCharges || "0");

//                         const totalUnit = oldUnit + newUnit;
//                         const totalAmount = oldAmount + newAmount;
//                         const totalIndirect = oldIndirect + newIndirect;

//                         // MAINTAIN PRICE PER UNIT (Weighted Average)
//                         // (Total Investment cost / Total Units)
//                         const maintainedPricePerUnit = totalUnit > 0
//                             ? ((totalAmount + totalIndirect) / totalUnit).toFixed(2)
//                             : "0.00";

//                         // Update the stock item inside the array
//                         targetStock.unit = totalUnit.toString();
//                         targetStock.total_amount = totalAmount.toString();
//                         targetStock.indirect_charges = totalIndirect.toString();
//                         targetStock.perUnitCharge = maintainedPricePerUnit;
//                         targetStock.total_amount_category = totalAmount.toString();

//                         // Update the Map with grouped data for this Row ID
//                         rowUpdates.set(existingRow.id, {
//                             updatedCategories: currentArray,
//                             lastCatId: catInfo.id,
//                             lastName: catInfo.stockName,
//                             lastCategory: categoryName,
//                             lastUnit: totalUnit.toString(),
//                             lastPrice: maintainedPricePerUnit, // This is the updated price per unit
//                             lastTotal: totalAmount.toString(),
//                             lastIndirect: totalIndirect.toString()
//                         });
//                     }
//                 } else {
//                     // 3. NEW STOCK -> COLLECT FOR POST
//                     categoriesToSubmitForPost.push({
//                         id: catInfo.id,
//                         stock_name: catInfo.stockName,
//                         unit: catInfo.unit,
//                         total_amount: catInfo.totalAmount,
//                         indirect_charges: catInfo.indirectCharges ?? "0",
//                         perUnitCharge: catInfo.perUnitCharge, // UI calculated value for new stocks
//                         category: categoryName,
//                         investment_type: isStructure ? "structure" : "direct",
//                         total_amount_category: catInfo.totalAmount
//                     });
//                 }
//             }
//         }

//         // Store the final grand total in setTotalAmmountSpend for global reporting
//         setTotalAmmountSpend(grandTotalAmount);

//         // ====== USERMETA update logic =========

//         const handleUserMetaUpdate = async () => {
//             // 1. Check if there's an existing meta record for this party_id and meta_key "remaining"
//             try {
//                 const usermetaResponse = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
//                 const usermetaList = await usermetaResponse.json();
//                 // Find meta with meta_key "remaining"
//                 const foundMeta = Array.isArray(usermetaList)
//                     ? usermetaList.find((meta: any) => meta.meta_key === "remaining" && String(meta.party_id) === String(data.partyId))
//                     : undefined;

//                 if (foundMeta) {
//                     // Update: remaining = oldvalue - grandTotalAmount
//                     const oldVal = parseFloat(foundMeta.meta_value || "0");
//                     const meta_value = (oldVal - grandTotalAmount).toString();
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`, {
//                         method: 'PUT',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                             meta_key: "remaining",
//                             meta_value,
//                             party_id: data.partyId,
//                         })
//                     });
//                 } else {
//                     // Create a new usermeta record with key "remaining"
//                     const remaining = ((Number(totalamountspend) || 0) - grandTotalAmount).toString();
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                             meta_key: "remaining",
//                             meta_value: remaining,
//                             party_id: data.partyId,
//                         })
//                     });
//                 }
//             } catch (err) {
//                 console.error("Usermeta API failed", err);
//             }
//         };

//         // --- API EXECUTION ---

//         // A. PUT UPDATES (For grouped existing stocks)
//         for (const [rowId, dataObj] of rowUpdates.entries()) {
//             const putBody = {
//                 id: rowId,
//                 cat_id: dataObj.lastCatId,
//                 name: dataObj.lastName,
//                 party_id: data.partyId || data.partyId,
//                 categories: JSON.stringify(dataObj.updatedCategories),
//                 category: dataObj.lastCategory,
//                 unit: dataObj.lastUnit,
//                 price_per_unit: dataObj.lastPrice, // Correctly maintained weighted average
//                 total_amount: dataObj.lastTotal,
//                 indirect_charges: dataObj.lastIndirect,
//                 date: data.date || ""
//             };

//             try {
//                 await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'PUT',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(putBody),
//                 });
//             } catch (err) {
//                 console.error("Update failed", err);
//             }
//         }

//         // B. POST NEW RECORDS
//         if (categoriesToSubmitForPost.length > 0) {
//             const postPayload = {
//                 party_id: data.partyId,
//                 date: data.date,
//                 investment_type: isStructure ? 'structure' : 'direct',
//                 categories: categoriesToSubmitForPost
//             };

//             try {
//                 await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(postPayload),
//                 });
//             } catch (err) {
//                 console.error("Post failed", err);
//             }
//         }

//         // C. USERMETA call for "remaining" value
//         await handleUserMetaUpdate();

//         alert('Submission finished successfully');
//         window.location.reload();
//     };
//     const handleSubmit = async (e?: React.FormEvent) => {
//         if (e) e.preventDefault();
//         if (!data.partyId) {
//             alert('Please select a party');
//             return;
//         }

//         let party: Party | undefined = partiesList.find(p => String(p.id) === String(data.partyId));
//         let availableTotalAmount = (party && party.total_amount !== undefined) ? Number(party.total_amount) : null;

//         if (availableTotalAmount == null) {
//             alert("Could not determine total amount available.");
//             return;
//         }

//         // Determine current investment type from state
//         const currentInvestmentType = investmentType === 'structure' ? 'structure' : 'direct';
//         const selectedCategories = Object.keys(categoryEntries);

//         if (selectedCategories.length === 0) {
//             alert('Please select at least one category');
//             return;
//         }

//         const rowUpdates = new Map();
//         let categoriesToSubmitForPost: any[] = [];
//         let grandTotalAmount = 0;

//         // Gather all category data for invoice: we want the same structure as `categoriesToSubmitForPost` usually
//         let datainvoiceAll: any[] = [];

//         for (const categoryName of selectedCategories) {
//             const entries = categoryEntries[categoryName];

//             for (const catInfo of entries) {
//                 if (!catInfo.stockName || !catInfo.stockName.trim()) continue;

//                 // Track Total Spend (Amount + Indirect Charges)
//                 const currentTotalAmount = parseFloat(catInfo.totalAmount || "0");
//                 const currentIndirectCharges = parseFloat(catInfo.indirectCharges || "0");
//                 grandTotalAmount += (currentTotalAmount + currentIndirectCharges);

//                 // Invoice data: push all for datainvoice
//                 datainvoiceAll.push({
//                     id: catInfo.id,
//                     stock_name: catInfo.stockName,
//                     unit: catInfo.unit,
//                     total_amount: catInfo.totalAmount,
//                     indirect_charges: catInfo.indirectCharges ?? "0",
//                     perUnitCharge: catInfo.perUnitCharge,
//                     category: categoryName,
//                     investment_type: currentInvestmentType,
//                     total_amount_category: catInfo.totalAmount
//                 });

//                 // 1. Find the existing row in the DB to decide between PUT or POST
//                 const existingRow = stocksDataDb.find(row => {
//                     if (String(row.party_id) !== String(data.partyId)) return false;
//                     let dbItems: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
//                     // Check if stock name AND category match in the same row
//                     return dbItems.some(item => item.stock_name === catInfo.stockName && item.category === categoryName);
//                 });

//                 if (existingRow) {
//                     // 2. PREPARE PUT DATA (Add to existing stock)
//                     let currentArray = rowUpdates.has(existingRow.id)
//                         ? rowUpdates.get(existingRow.id).updatedCategories
//                         : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories]);

//                     let targetStock = currentArray.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);

//                     if (targetStock) {
//                         const oldUnit = parseFloat(targetStock.unit || "0");
//                         const oldAmount = parseFloat(targetStock.total_amount || "0");
//                         const oldIndirect = parseFloat(targetStock.indirect_charges || "0");

//                         const newUnit = parseFloat(catInfo.unit || "0");
//                         const newAmount = parseFloat(catInfo.totalAmount || "0");
//                         const newIndirect = parseFloat(catInfo.indirectCharges || "0");

//                         const totalUnit = oldUnit + newUnit;
//                         const totalAmount = oldAmount + newAmount;
//                         const totalIndirect = oldIndirect + newIndirect;

//                         // Weighted Average Calculation
//                         const maintainedPricePerUnit = totalUnit > 0
//                             ? ((totalAmount + totalIndirect) / totalUnit).toFixed(2)
//                             : "0.00";

//                         targetStock.unit = totalUnit.toString();
//                         targetStock.total_amount = totalAmount.toString();
//                         targetStock.indirect_charges = totalIndirect.toString();
//                         targetStock.perUnitCharge = maintainedPricePerUnit;
//                         targetStock.total_amount_category = totalAmount.toString();
//                         // Ensure the investment_type is maintained/updated correctly
//                         targetStock.investment_type = currentInvestmentType;

//                         rowUpdates.set(existingRow.id, {
//                             updatedCategories: currentArray,
//                             lastCatId: catInfo.id,
//                             lastName: catInfo.stockName,
//                             lastCategory: categoryName,
//                             lastUnit: totalUnit.toString(),
//                             lastPrice: maintainedPricePerUnit,
//                             lastTotal: totalAmount.toString(),
//                             lastIndirect: totalIndirect.toString()
//                         });
//                     }
//                 } else {
//                     // 3. PREPARE POST DATA (Completely new stock)
//                     categoriesToSubmitForPost.push({
//                         id: catInfo.id,
//                         stock_name: catInfo.stockName,
//                         unit: catInfo.unit,
//                         total_amount: catInfo.totalAmount,
//                         indirect_charges: catInfo.indirectCharges ?? "0",
//                         perUnitCharge: catInfo.perUnitCharge,
//                         category: categoryName,
//                         investment_type: currentInvestmentType, // Set dynamically
//                         total_amount_category: catInfo.totalAmount
//                     });
//                 }
//             }
//         }

//         // Optional: Global state update if you use this elsewhere
//         if (typeof setTotalAmmountSpend === 'function') setTotalAmmountSpend(grandTotalAmount);

//         // Send grandTotalAmount to buysellrecord API as totalpurchase, with totalsell and closingBLC as 0
//         try {
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     date: data.date,
//                     totalpurchase: grandTotalAmount,
//                     totalsell: 0,
//                     closingBLC: 0
//                 })
//             });
//         } catch (err) {
//             // Log, but don't block user
//             console.error("Failed to send buysellrecord (addstock)", err);
//         }

//         // Prepare invoice data and send invoice API call here (for every submission except direct payment which is handled separately)
//         const invoicePayload = {
//             farm: farmName,
//             party: data.partyId,
//             invoice_type: "purchase",
//             date: data.date,
//             datainvoice: datainvoiceAll
//         };
//         try {
//             await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(invoicePayload)
//             });
//         } catch (err) {
//             console.error('Error adding invoice:', err);
//             // Optionally alert, but do not block main flow on error
//         }

//         // Balance update logic
//         const handleUserMetaUpdate = async (amountToDeduct: number) => {
//             try {
//                 const usermetaResponse = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
//                 const usermetaList = await usermetaResponse.json();
//                 const foundMeta = Array.isArray(usermetaList)
//                     ? usermetaList.find((meta: any) => meta.meta_key === "remaining" && String(meta.party_id) === String(data.partyId))
//                     : undefined;

//                 if (foundMeta) {
//                     const oldVal = parseFloat(foundMeta.meta_value || "0");
//                     const meta_value = (oldVal - amountToDeduct).toString();
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${foundMeta.id}`, {
//                         method: 'PUT',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({ meta_key: "remaining", meta_value, party_id: data.partyId })
//                     });
//                 } else {
//                     // remaining = Initial Party Amount - Spend
//                     const remaining = ((availableTotalAmount || 0) - amountToDeduct).toString();
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({ meta_key: "remaining", meta_value: remaining, party_id: data.partyId })
//                     });
//                 }
//             } catch (err) {
//                 console.error("Usermeta update failed", err);
//             }
//         };

//         if (investmentType === 'direct') {
//             const payment = safeNumber(directPaymentAmount);

//             if (payment <= 0) {
//                 alert("Please enter valid payment amount");
//                 return;
//             }

//             const nextId = getNextCategoryId();

//             // 👉 Create virtual category entry
//             const directCategory = [{
//                 id: nextId,
//                 stock_name: "DirectPayment", // or dynamic if needed
//                 unit: "0",
//                 total_amount: payment.toString(),
//                 category: "Equity",
//                 indirect_charges: "0",
//                 perUnitCharge: "0",
//                 investment_type: "direct",
//                 total_amount_category: payment.toString()
//             }];

//             try {
//                 await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         party_id: data.partyId,
//                         date: data.date,
//                         investment_type: "direct",
//                         categories: directCategory
//                     }),
//                 });

//                 // Also send invoice for direct payment case:
//                 const invoiceDirectPayload = {
//                     farm: "Rajnish",
//                     party: data.partyId,
//                     invoice_type: "purchase",
//                     date: data.date,
//                     datainvoice: JSON.stringify(directCategory)
//                 };
//                 try {
//                     await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(invoiceDirectPayload)
//                     });
//                 } catch (err) {
//                     // Only log, don't interrupt flow
//                     console.error('Error adding direct payment invoice:', err);
//                 }

//                 await handleUserMetaUpdate(payment);

//                 alert("Direct payment submitted");
//                 window.location.reload();
//                 return;
//             } catch (err) {
//                 console.error(err);
//                 alert("Error in direct payment");
//                 return;
//             }
//         }
//         // EXECUTION
//         try {
//             // A. PUT UPDATES
//             for (const [rowId, dataObj] of rowUpdates.entries()) {
//                 const putBody = {
//                     id: rowId,
//                     party_id: data.partyId,
//                     categories: JSON.stringify(dataObj.updatedCategories),
//                     // Fields usually required by the single-row schema fallback
//                     name: dataObj.lastName,
//                     category: dataObj.lastCategory,
//                     unit: dataObj.lastUnit,
//                     price_per_unit: dataObj.lastPrice,
//                     total_amount: dataObj.lastTotal,
//                     indirect_charges: dataObj.lastIndirect,
//                     investment_type: currentInvestmentType,
//                     date: data.date || new Date().toISOString().split('T')[0]
//                 };

//                 await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'PUT',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(putBody),
//                 });
//             }

//             // B. POST NEW RECORDS
//             if (categoriesToSubmitForPost.length > 0) {
//                 const postPayload = {
//                     party_id: data.partyId,
//                     date: data.date,
//                     investment_type: currentInvestmentType,
//                     categories: categoriesToSubmitForPost
//                 };

//                 await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify(postPayload),
//                 });
//             }

//             await handleUserMetaUpdate(grandTotalAmount);
//             alert('Submission successful');
//             window.location.reload();
//         } catch (err) {
//             console.error("Submission failed", err);
//             alert("An error occurred during submission.");
//         }
//     };
//     // Withdrawal logic (unchanged) --
//     useEffect(() => {
//         debugger;
//         if (!withdrawal.partyId) {
//             setWithdrawCategoriesDb([]);
//             setWithdrawStocksDb([]);
//             setWithdrawalInvestmentType('structure');
//             setWithdrawalDirectPayment('');
//             return;
//         }
//         const relevantDbRows: PartyStockDBType[] = (stocksDataDb || []).filter(row =>
//             String(row.party_id) === String(withdrawal.partyId)
//         );
//         let newCats: string[] = [];
//         let newStocksDb: StockDBCategoryItem[] = [];
//         for (const row of relevantDbRows) {
//             let catsArr: StockDBCategoryItem[] = [];
//             if (typeof row.categories === 'string') {
//                 try {
//                     const parsed = JSON.parse(row.categories);
//                     // Only include items that look like StockDBCategoryItem (i.e., have required keys)
//                     catsArr = Array.isArray(parsed) ? parsed.filter(item =>
//                         typeof item === "object" &&
//                         item !== null &&
//                         "category" in item &&
//                         "stock_name" in item &&
//                         "unit" in item &&
//                         "total_amount" in item &&
//                         "indirect_charges" in item &&
//                         "perUnitCharge" in item
//                     ) : [];
//                 } catch (e) {
//                     catsArr = [];
//                 }
//             } else if (Array.isArray(row.categories)) {
//                 // Only include objects that match shape of StockDBCategoryItem
//                 catsArr = (row.categories as any[]).filter(item =>
//                     typeof item === "object" &&
//                     item !== null &&
//                     "category" in item &&
//                     "stock_name" in item &&
//                     "unit" in item &&
//                     "total_amount" in item &&
//                     "indirect_charges" in item &&
//                     "perUnitCharge" in item
//                 ) as StockDBCategoryItem[];
//             }
//             debugger;
//             catsArr.forEach(item => {
//                 if (item.category && !newCats.includes(item.category)) {
//                     newCats.push(item.category);
//                 }
//                 newStocksDb.push(item);
//             });
//         }
//         setWithdrawCategoriesDb(newCats);
//         setWithdrawStocksDb(newStocksDb);
//         setWithdrawalInvestmentType('structure');
//         setWithdrawalDirectPayment('');
//     }, [withdrawal.partyId, stocksDb]);

//     const withdrawalStockOptions = useMemo<StockDBCategoryItem[]>(() => {
//         if (!withdrawal.partyId || !withdrawal.category) return [];
//         return withdrawStocksDb.filter(item => item.category === withdrawal.category);
//     }, [withdrawal.partyId, withdrawal.category, withdrawStocksDb]);

//     const withdrawalUnitLimit: number = useMemo(() => {
//         if (!withdrawal.partyId || !withdrawal.category || !withdrawal.stockName) return 0;
//         const item = withdrawalStockOptions.find(
//             s => s.stock_name === withdrawal.stockName
//         );
//         let unit = 0;
//         if (item && item.unit) {
//             const n = parseFloat(item.unit);
//             if (!isNaN(n)) unit = n;
//         }
//         return unit;
//     }, [withdrawal.partyId, withdrawal.category, withdrawal.stockName, withdrawalStockOptions]);

//     const handleWithdrawalInput = (
//         e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
//     ) => {
//         const { name, value } = e.target;

//         if (name === 'withdrawalInvestmentType') {
//             setWithdrawalInvestmentType(value as 'direct' | 'structure');
//             setWithdrawalDirectPayment('');
//             setWithdrawal((prev) => ({
//                 ...prev,
//                 category: '',
//                 stockId: '',
//                 stockName: '',
//                 sale: '',
//                 date: '',
//             }));
//             return;
//         }

//         setWithdrawal(prev => {
//             let changes: any = { [name]: value };
//             if (name === "partyId") {
//                 changes = { ...changes, category: '', stockId: '', stockName: '', sale: '', date: '' };
//             }
//             if (name === "category") {
//                 changes = { ...changes, stockId: '', stockName: '', sale: '' };
//             }
//             if (name === "stockName") {
//                 let foundStock = withdrawalStockOptions.find(item => item.stock_name === value);
//                 changes.stockId = foundStock ? foundStock.id : '';
//             }
//             return { ...prev, ...changes };
//         });
//     };

//     const resetWithdrawalForm = () => {
//         setWithdrawal({
//             partyId: '',
//             category: '',
//             stockId: '',
//             stockName: '',
//             sale: '',
//             date: '',
//         });
//         setWithdrawalInvestmentType('structure');
//         setWithdrawalDirectPayment('');
//     };

//     const handleWithdrawalSubmit = async (e?: React.FormEvent) => {
//         debugger;
//         if (e) e.preventDefault();
       

//         if (!withdrawal.partyId) {
//             alert("Please select a party for withdrawal.");
//             return;
//         }

//         if (withdrawalInvestmentType === 'direct') {
//             if (!withdrawalDirectPayment || isNaN(Number(withdrawalDirectPayment)) || Number(withdrawalDirectPayment) <= 0) {
//                 alert('Please enter a valid payment amount');
//                 return;
//             }
//             const payload = {
//                 party_id: withdrawal.partyId,
//                 date: withdrawal.date || null,
//                 amount: withdrawalDirectPayment,
//                 categories: JSON.stringify([{ investment_type: 'direct' }])
//             };
//             setWithdrawalLoading(true);
//             try {
//                 const res = await fetch(
//                     `${process.env.REACT_APP_API_URL}/auth/addwithdrawal`,
//                     {
//                         method: "POST",
//                         headers: { "Content-Type": "application/json" },
//                         body: JSON.stringify(payload),
//                     }
//                 );
//                 const result = await res.json();
//                 if (!res.ok) {
//                     throw new Error(result?.message || "Failed to add withdrawal");
//                 }
//                 alert("Withdrawal added successfully!");
//                 resetWithdrawalForm();
//                 setShowWithdrawalModal(false);
//                 // RELOAD PAGE after withdrawal submit
//                 window.location.reload();
//             } catch (err: any) {
//                 alert("Error: " + (err?.message ?? "Something went wrong"));
//             } finally {
//                 setWithdrawalLoading(false);
//             }
//             return;
//         }

//         if (!withdrawal.category) {
//             alert("Please select a category.");
//             return;
//         }
//         if (!withdrawal.stockName) {
//             alert("Please select a stock.");
//             return;
//         }
//         if (!withdrawal.stockId) {
//             alert("Invalid or missing stock id.");
//             return;
//         }
       
//         if (!withdrawal.date) {
//             alert("Please select a date.");
//             return;
//         }
//         const saleValue = parseFloat(withdrawal.sale);
//         if (withdrawalUnitLimit > 0 && saleValue > withdrawalUnitLimit) {
//             alert(
//                 `You don't have enough unit for this withdrawal. Available unit: ${withdrawalUnitLimit}, you entered: ${withdrawal.sale}`
//             );
//             return;
//         }
//         if (withdrawalUnitLimit === 0) {
//             alert(
//                 `No units found for this stock under the selected party and category.`
//             );
//             return;
//         }
//         if (!withdrawal.stockId || !String(withdrawal.stockId).trim()) {
//             alert("Stock ID cannot be blank.");
//             return;
//         }

//         // Build categories as an array with all required fields and stringify
//         const categoriesArr = [
//             {
//                 category: withdrawal.category,
//                 stockName: withdrawal.stockName,
//                 investment_type: 'indirect'
//             }
//         ];

//         const payload = {
//             party_id: withdrawal.partyId,
//             categories: JSON.stringify(categoriesArr),
//             stock_id: withdrawal.stockId,
//             amount: withdrawalDirectPayment,
//             date: withdrawal.date,
//             investment_type: 'structure',
//         };

//         setWithdrawalLoading(true);

//         try {
//             const res = await fetch(
//                 `${process.env.REACT_APP_API_URL}/auth/addwithdrawal`,
//                 {
//                     method: "POST",
//                     headers: { "Content-Type": "application/json" },
//                     body: JSON.stringify(payload),
//                 }
//             );
//             const result = await res.json();
//             if (!res.ok) {
//                 throw new Error(result?.message || "Failed to add withdrawal");
//             }
//             alert("Withdrawal added successfully!");
//             resetWithdrawalForm();
//             setShowWithdrawalModal(false);
//             // RELOAD PAGE after withdrawal submit
//             window.location.reload();
//         } catch (err: any) {
//             alert("Error: " + (err?.message ?? "Something went wrong"));
//         } finally {
//             setWithdrawalLoading(false);
//         }
//     };

//     return (
//         <>
//             <div className='p-6'>
//                 <div className='w-full flex justify-between'>
//                     <h1 className='text-[28px] text-[#101828] font-[500]'>Add new stock</h1>
//                     <div className="flex gap-3">
//                         <button
//                             type="button"
//                             className="flex items-center justify-center gap-2 text-[16px] font-[500] text-[#fff] bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8"
//                             onClick={() => window.location.href = '/withdraw'}
//                         >
//                             Add Withdrawal
//                         </button>
//                         <button
//                             type="button"
//                             className="flex items-center justify-center gap-2 text-[16px] font-[500] text-[#fff] bg-gradient-to-r from-[#FF9500] to-[#1CAC70] py-2 rounded-[8px] px-8"
//                             onClick={() => window.location.href = '/sell-stock'}
//                         >
//                             Sell Stock
//                         </button>
//                     </div>
//                 </div>
//                 <form
//                     className='bg-[#ffff] p-5 w-full rounded-[10px] mt-4'
//                     onSubmit={handleSubmit}
//                     autoComplete="off"
//                 >
//                     <div className='flex flex-wrap w-full justify-between mt-4 gap-4'>
//                         {/* Party selection */}
//                         <div className='w-[100%] md:w-[48%]'>
//                             <label htmlFor="partyId">Party Name</label>
//                             <br />
//                             <select
//                                 name="partyId"
//                                 id="partyId"
//                                 value={data.partyId || urlParty}
//                                 onChange={handleInput}
//                                 className='w-[100%] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                 required
//                             >
//                                 <option value="">Choose Party</option>
//                                 {partiesList.map((p) => (
//                                     <option key={p.id} value={String(p.id)}>
//                                         {p.name}
//                                     </option>
//                                 ))}
//                             </select>
//                             {selectedPartyTotalAmount !== null && (
//                                 <div className="text-xs text-blue-600 mt-1">
//                                     Total Available Amount: {selectedPartyTotalAmount}
//                                 </div>
//                             )}
//                             {deductedAvailable !== null && (
//                                 <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? "#D8000C" : "#007200" }}>
//                                     Available After Deduction: {deductedAvailable}
//                                 </div>
//                             )}
//                         </div>
//                         {/* Date of Purchase */}
//                         <div className='w-[100%] md:w-[48%]'>
//                             <label htmlFor="date">Date Of Purchase</label>
//                             <br />
//                             <input
//                                 type="date"
//                                 name="date"
//                                 id="date"
//                                 placeholder='Purchase date'
//                                 value={data.date}
//                                 onChange={handleInput}
//                                 className='w-[100%] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                 autoComplete="off"
//                             />
//                         </div>
//                         {/* Investment Type */}
//                         <div className='flex flex-wrap w-full justify-between mt-4 gap-4'>
//                         <div className='w-[100%] md:w-[48%]'>
//                             <label htmlFor="investmentType">Investment</label>
//                             <br />
//                             <select
//                                 name="investmentType"
//                                 id="investmentType"
//                                 value={investmentType}
//                                 onChange={handleInvestmentTypeChange}
//                                 className='w-[100%] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                 required
//                             >
//                                 <option value="direct">Direct Payment</option>
//                                 <option value="structure">Structure Payment</option>
//                             </select>
//                         </div>
//                     </div>
//                     {investmentType === 'direct' && (
//                         <div className='flex flex-wrap w-full justify-between mt-4 gap-4'>
//                             <div className='w-[100%] md:w-[48%]'>
//                                 <label htmlFor="directPaymentAmount">Payment Amount</label>
//                                 <br />
//                                 <input
//                                     type="number"
//                                     name="directPaymentAmount"
//                                     id="directPaymentAmount"
//                                     placeholder="Enter payment amount"
//                                     value={directPaymentAmount}
//                                     min={0}
//                                     step="any"
//                                     onChange={e => setDirectPaymentAmount(e.target.value)}
//                                     className='w-[100%] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                     required
//                                 />
//                                 {selectedPartyTotalAmount !== null && !!directPaymentAmount && (
//                                     <div className="text-xs mt-1"
//                                         style={{
//                                             color: Number(directPaymentAmount) > (selectedPartyTotalAmount - calculateTotalDeductedFromStockTable(stocksDataDb, data.partyId)) ? "#D8000C" : "#007200"
//                                         }}>
//                                         {Number(directPaymentAmount) > (selectedPartyTotalAmount - calculateTotalDeductedFromStockTable(stocksDataDb, data.partyId))
//                                             ? `Not enough available. You are over by ${Number(directPaymentAmount) - (selectedPartyTotalAmount - calculateTotalDeductedFromStockTable(stocksDataDb, data.partyId))}`
//                                             : `You have enough amount.`}
//                                     </div>
//                                 )}
//                                 <p className='mt-5 w-full'>Categories</p>
//                                 <div className="flex flex-wrap gap-4 p-3 bg-gradient-to-r from-[#F9FAFB] to-[#F4F2FF] rounded-xl shadow-sm border border-[#ececec] w-full">
//                                     {possibleCategories.map((cat) => (
//                                         <div
//                                             key={cat.id}
//                                             className={`flex items-center gap-2 py-2 px-4 rounded-lg transition-all duration-200 cursor-pointer border-2 ${
//                                                 isChecked(cat)
//                                                     ? "bg-gradient-to-r from-[#1CAC70]/10 to-[#FF9500]/10 border-[#FF9500] shadow-md text-[#FF9500] font-semibold"
//                                                     : "bg-white border-[#ececec] hover:shadow-lg text-[#344054]"
//                                             }`}
//                                             style={{ minWidth: 180 }}
//                                             onClick={() => handleCategory(cat)}
//                                             tabIndex={0}
//                                             role="button"
//                                         >
//                                             <input
//                                                 type="checkbox"
//                                                 checked={isChecked(cat)}
//                                                 onChange={() => handleCategory(cat)}
//                                                 className="form-checkbox h-5 w-5 accent-[#FF9500] rounded focus:ring-2 focus:ring-[#FF9500] transition"
//                                                 style={{ cursor: "pointer" }}
//                                                 onClick={e => e.stopPropagation()}
//                                             />
//                                             <span className="text-[16px]">{cat.category_name}</span>
//                                         </div>
//                                     ))}
//                                 </div>
//                                 {deductedAvailable !== null && (
//                                     <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? "#D8000C" : "#007200" }}>
//                                         Available After Deduction: {deductedAvailable}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     )}

//                     {investmentType === 'structure' && (
//                         <>
//                             <p className='mt-5 w-full'>Categories</p>
//                             <div className="flex flex-col gap-2 p-2">
//                                 {possibleCategories.map((cat) => {
//                                     const entries = categoryEntries[cat.category_name] || [];
//                                     return (
//                                         <div key={cat.id} className="flex flex-col gap-1">
//                                             <label className="flex items-center gap-2 cursor-pointer text-[#344054] text-[16px]">
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={isChecked(cat)}
//                                                     onChange={() => handleCategory(cat)}
//                                                 />
//                                                 {cat.category_name}
//                                             </label>
//                                             {isChecked(cat) && (
//                                                 <div className="flex flex-col gap-3 ml-5 w-full border-l-[2px] border-[#ececec] pl-4 mt-2 mb-2">
//                                                     {(entries || []).map((entry, entryIdx) => {
//                                                         // Restriction and disabling logic removed
//                                                         return (
//                                                             <div key={`${cat.category_name}-entry-${entry.id}`} className="flex flex-wrap gap-2 items-end w-full relative">
//                                                                 <div className='flex flex-col'>
//                                                                     <label htmlFor={`stockid-${cat.category_name}-${entryIdx}`} className="text-[13px]">ID</label>
//                                                                     <input
//                                                                         id={`stockid-${cat.category_name}-${entryIdx}`}
//                                                                         type="text"
//                                                                         value={entry.id}
//                                                                         readOnly
//                                                                         className="w-[60px] bg-gray-50 border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#5E5E5E] text-[13px] outline-none"
//                                                                     />
//                                                                 </div>
//                                                                 <div className="flex flex-col">
//                                                                   <label
//                                                                     htmlFor={`stockname-${cat.category_name}-${entryIdx}`}
//                                                                     className="text-[13px]"
//                                                                   >
//                                                                     Stock Name
//                                                                   </label>
//                                                                   <AsyncSelect
//   cacheOptions
//   defaultOptions={false}
//   loadOptions={(inputValue, callback) => {
//     if (!inputValue || inputValue.length < 2) {
//       callback([]);
//       return;
//     }
  
//     const isMutual = 
//       cat.category_name === "Mutual Fund" ||
//       cat.category_name === "Mutual Funds" ||
//       cat.category_name === "MutualFund" ||
//       cat.category_name.toLowerCase().includes("mutual"); // catches any variation
  
//     const source = isMutual ? mutualsnames : stocksnames;
  
//     const lower = inputValue.toLowerCase();
//     const filtered = source
//       .filter(s => s.name && s.name.toLowerCase().includes(lower))
//       .slice(0, 100)
//       .map(s => ({ value: s.name, label: s.name }));
  
//     callback(filtered);
//   }}
//   value={
//     entry.stockName
//       ? { value: entry.stockName, label: entry.stockName }
//       : null
//   }
//   onChange={(selected) =>
//     handleCategoryFieldChange(
//       cat,
//       entryIdx,
//       "stockName",
//       selected?.value || ""
//     )
//   }
//   placeholder={
//     cat.category_name === "Mutual Funds"
//       ? "Search Mutual Fund..."
//       : "Search Stock Name..."
//   }
//   className="text-[13px]"
//   styles={{
//     control: (base) => ({
//       ...base,
//       borderRadius: "8px",
//       borderColor: "#D0D5DD",
//       minHeight: "40px",
//       width: "240px"
//     })
//   }}
// />
//                                                                 </div>
//                                                                 <div className='flex flex-col'>
//                                                                     <label htmlFor={`unit-${cat.category_name}-${entryIdx}`} className="text-[13px]">Unit</label>
//                                                                     <input
//                                                                         id={`unit-${cat.category_name}-${entryIdx}`}
//                                                                         type="number"
//                                                                         min={0}
//                                                                         step="any"
//                                                                         placeholder="Enter unit"
//                                                                         value={entry.unit}
//                                                                         onChange={e =>
//                                                                             handleCategoryFieldChange(cat, entryIdx, "unit", e.target.value)
//                                                                         }
//                                                                         className="w-[120px] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[13px] outline-none"
//                                                                         required
//                                                                     />
//                                                                 </div>
//                                                                 <div className='flex flex-col'>
//                                                                     <label htmlFor={`ta-${cat.category_name}-${entryIdx}`} className="text-[13px]">
//                                                                         Total Amount
//                                                                     </label>
//                                                                     <input
//                                                                         id={`ta-${cat.category_name}-${entryIdx}`}
//                                                                         type="number"
//                                                                         min={0}
//                                                                         step="any"
//                                                                         placeholder="Total amount for this stock"
//                                                                         value={entry.totalAmount}
//                                                                         onChange={e => handleCategoryFieldChange(cat, entryIdx, "totalAmount", e.target.value)}
//                                                                         className={
//                                                                             "w-[140px] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[13px] outline-none"
//                                                                         }
//                                                                         required
//                                                                     />
//                                                                 </div>
//                                                                 <div className='flex flex-col'>
//                                                                     <label htmlFor={`ic-${cat.category_name}-${entryIdx}`} className="text-[13px]">Indirect Charges</label>
//                                                                     <input
//                                                                         id={`ic-${cat.category_name}-${entryIdx}`}
//                                                                         type="number"
//                                                                         min={0}
//                                                                         step="any"
//                                                                         placeholder="Indirect charges"
//                                                                         value={entry.indirectCharges}
//                                                                         onChange={e => handleCategoryFieldChange(cat, entryIdx, "indirectCharges", e.target.value)}
//                                                                         className={
//                                                                             "w-[140px] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[13px] outline-none"
//                                                                         }
//                                                                         required
//                                                                     />
//                                                                 </div>
//                                                                 <div className='flex flex-col'>
//                                                                     <label htmlFor={`puc-${cat.category_name}-${entryIdx}`} className="text-[13px]">Per Unit Charge</label>
//                                                                     <input
//                                                                         id={`puc-${cat.category_name}-${entryIdx}`}
//                                                                         type="number"
//                                                                         min={0}
//                                                                         step="any"
//                                                                         placeholder="Per Unit Charge"
//                                                                         value={entry.perUnitCharge}
//                                                                         onChange={e =>
//                                                                             handleCategoryFieldChange(cat, entryIdx, "perUnitCharge", e.target.value)
//                                                                         }
//                                                                         className={`w-[140px] border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[13px] outline-none ${entry.autoCalculated && !!entry.unit ? "bg-gray-100" : ""}`}
//                                                                         readOnly={entry.autoCalculated && !!entry.unit}
//                                                                         required
//                                                                     />
//                                                                     {entry.autoCalculated && !!entry.unit && (
//                                                                         <span className="text-xs text-green-500">Auto-calculated</span>
//                                                                     )}
//                                                                 </div>
//                                                                 <button
//                                                                     type="button"
//                                                                     title="Remove entry"
//                                                                     onClick={() => handleRemoveEntry(cat, entryIdx)}
//                                                                     className="ml-2 text-red-500 hover:text-red-700 rounded px-2 py-1 border border-red-200 bg-red-50 flex items-center justify-center text-xs"
//                                                                     style={{ height: '32px' }}
//                                                                 >
//                                                                     Remove
//                                                                 </button>
//                                                             </div>
//                                                         )
//                                                     })}
//                                                     <button
//                                                         type="button"
//                                                         className="mt-1 text-sm text-blue-500 hover:text-blue-700 font-semibold px-2 py-1 border border-blue-200 rounded bg-blue-50 flex items-center w-fit mb-1"
//                                                         onClick={() => handleAddEntry(cat)}
//                                                     >
//                                                         + Add another for {cat.category_name}
//                                                     </button>
//                                                     {selectedPartyTotalAmount !== null && entries.length > 0 && (
//                                                         <div className="mt-1 text-xs text-blue-700">
//                                                             {(() => {
//                                                                 const alreadyDeducted = calculateTotalDeductedFromStockTable(stocksDataDb, data.partyId);
//                                                                 let additional = 0;
//                                                                 Object.entries(categoryEntries).forEach(([category, ents]) => {
//                                                                     ents.forEach(ent => {
//                                                                         let amt = parseFloat(ent.totalAmount || "0");
//                                                                         let indirect = parseFloat(ent.indirectCharges || "0");
//                                                                         if (!isNaN(amt)) additional += amt;
//                                                                         if (!isNaN(indirect)) additional += indirect;
//                                                                     });
//                                                                 });
//                                                                 // return `Total used (from stock table): ${alreadyDeducted}, New allocation: ${additional}, of available: ${selectedPartyTotalAmount}`;
//                                                                 return `New allocation: ${additional}, of available: ${selectedPartyTotalAmount}`;
//                                                             })()}
//                                                             {(() => {
//                                                                 const alreadyDeducted = calculateTotalDeductedFromStockTable(stocksDataDb, data.partyId);
//                                                                 let additional = 0;
//                                                                 Object.entries(categoryEntries).forEach(([category, ents]) => {
//                                                                     ents.forEach(ent => {
//                                                                         let amt = parseFloat(ent.totalAmount || "0");
//                                                                         let indirect = parseFloat(ent.indirectCharges || "0");
//                                                                         if (!isNaN(amt)) additional += amt;
//                                                                         if (!isNaN(indirect)) additional += indirect;
//                                                                     });
//                                                                 });
//                                                                 if (alreadyDeducted + additional > Number(selectedPartyTotalAmount))
//                                                                     return (
//                                                                         <span className="text-red-500 ml-3">
//                                                                             Not enough amount! You are allocating {alreadyDeducted + additional - Number(selectedPartyTotalAmount)} over available amount.
//                                                                         </span>
//                                                                     );
//                                                                 return null;
//                                                             })()}
//                                                             {deductedAvailable !== null && (
//                                                                 <span className="ml-4" style={{ color: deductedAvailable < 0 ? "#D8000C" : "#007200" }}>
//                                                                     Available After Deduction: {deductedAvailable}
//                                                                 </span>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </>
//                     )}
//                     </div>
//                     <button
//                         type="submit"
//                         className="mt-6 flex items-center justify-center gap-2 text-[16px] font-[500] text-[#fff] bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8"
//                     >
//                         Submit
//                     </button>
//                 </form>
//             </div>
//             {/* ============== Sell Stock Modal ============== */}
//             {showSellStockModal && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//                     <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md h-full max-h-[90vh] flex flex-col">
//                         {/* Header */}
//                         <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 bg-gray-50 rounded-t-xl">
//                             <h2 className="text-xl font-semibold text-gray-800">Sell Stock</h2>
//                             <button
//                                 onClick={() => {
//                                     setShowSellStockModal(false);
//                                     setSellStockForm({
//                                         partyId: '',
//                                         category: '',
//                                         stockId: '',
//                                         stockName: '',
//                                         sellUnits: '',
//                                         sellAmount: '',
//                                         indirectCharges: '',
//                                         date: '',
//                                     });
//                                 }}
//                                 className="text-gray-400 hover:text-gray-700 text-2xl"
//                                 aria-label="Close"
//                             >
//                                 ×
//                             </button>
//                         </div>
//                         {/* Scrollable Form */}
//                         <div className="overflow-y-auto flex-1 px-6 py-4">
//                             <form
//                                 id="sell-stock-form-modal"
//                                 onSubmit={handleSellStockSubmit}
//                                 autoComplete="off"
//                                 className="flex flex-col gap-4"
//                             >
//                                 <div>
//                                     <label htmlFor="sellstock-partyId" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Party Name
//                                     </label>
//                                     <select
//                                         name="partyId"
//                                         id="sellstock-partyId"
//                                         value={sellStockForm.partyId} 
                                        
//                                         onChange={handleSellStockFormChange}
//                                         required
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500"
//                                     >
//                                         <option value="">Choose Party</option>
//                                         {partiesList.map((p) => (
//                                             <option key={p.id} value={String(p.id)}>
//                                                 {p.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-category" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Category
//                                     </label>
//                                     <select
//                                         name="category"
//                                         id="sellstock-category"
//                                         value={sellStockForm.category}
//                                         onChange={handleSellStockFormChange}
//                                         required
//                                         disabled={!sellStockForm.partyId}
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                     >
//                                         <option value="">Select Category</option>
//                                         {sellPartyCategories.map(cat => (
//                                             <option key={cat} value={cat}>{cat}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-stockId" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Stock Name
//                                     </label>
//                                     <select
//                                         name="stockId"
//                                         id="sellstock-stockId"
//                                         value={sellStockForm.stockId}
//                                         onChange={handleSellStockFormChange}
//                                         required
//                                         disabled={!sellStockForm.partyId || !sellStockForm.category}
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                     >
//                                         <option value="">Select Stock</option>
//                                         {sellCategoryStocks.map(stock => (
//                                             <option key={stock.id} value={stock.id}>
//                                                 {stock.stock_name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-sellUnits" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Units To Sell
//                                         {sellStockForm.partyId && sellStockForm.category && sellStockForm.stockId ? (
//                                             <span className="text-xs text-gray-500 ml-2">
//                                                 (Available: {sellStockAvailableDetails.unit})
//                                             </span>
//                                         ) : null}
//                                     </label>
//                                     <input
//                                         type="number"
//                                         name="sellUnits"
//                                         id="sellstock-sellUnits"
//                                         placeholder="How many units to sell"
//                                         value={sellStockForm.sellUnits}
//                                         min={0}
//                                         max={sellStockAvailableDetails.unit || undefined}
//                                         onChange={handleSellStockFormChange}
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                         required
//                                         disabled={!sellStockForm.stockId}
//                                     />
//                                     {sellStockForm.sellUnits && parseFloat(sellStockForm.sellUnits) > sellStockAvailableDetails.unit ? (
//                                         <span className="text-xs text-red-500">
//                                             Not enough units available!
//                                         </span>
//                                     ) : null}
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-sellAmount" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Amount for which you are selling stocks
//                                     </label>
//                                     <input
//                                         type="number"
//                                         name="sellAmount"
//                                         id="sellstock-sellAmount"
//                                         placeholder="Enter sell amount"
//                                         value={sellStockForm.sellAmount || ""}
//                                         min={0}
//                                         step="any"
//                                         onChange={handleSellStockFormChange}
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                         required
//                                         disabled={!sellStockForm.stockId}
//                                     />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-indirectCharges" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Indirect Charges
//                                     </label>
//                                     <input
//                                         type="number"
//                                         name="indirectCharges"
//                                         id="sellstock-indirectCharges"
//                                         placeholder="Enter indirect charges (if any)"
//                                         value={sellStockForm.indirectCharges || ""}
//                                         min={0}
//                                         step="any"
//                                         onChange={handleSellStockFormChange}
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                         disabled={!sellStockForm.stockId}
//                                     />
//                                 </div>
//                                 <div>
//                                     <label htmlFor="sellstock-date" className="block text-sm font-medium text-gray-700 mb-1">
//                                         Date
//                                     </label>
//                                     <input
//                                         type="date"
//                                         name="date"
//                                         id="sellstock-date"
//                                         value={sellStockForm.date}
//                                         onChange={handleSellStockFormChange}
//                                         required
//                                         className="w-full border border-gray-300 p-2.5 rounded-md text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:bg-gray-100"
//                                         disabled={!sellStockForm.stockId}
//                                     />
//                                 </div>
//                                 <div className="bg-gray-50 rounded-md p-3 text-sm">
//                                     <label className="block font-medium text-gray-700 mb-1">
//                                         Sell Amount (auto):
//                                         <span className="font-semibold text-gray-800 ml-2">
//                                             {sellStockForm.sellAmount && sellStockForm.sellUnits && parseFloat(sellStockForm.sellUnits) > 0
//                                                 ? (
//                                                     <>
//                                                         {(parseFloat(sellStockForm.sellAmount) / parseFloat(sellStockForm.sellUnits)).toFixed(2)}
//                                                         <span className="text-xs text-gray-500 ml-2">(per unit)</span>
//                                                     </>
//                                                 )
//                                                 : (
//                                                     <>
//                                                         {sellStockFormAmount.toFixed(2)}
//                                                     </>
//                                                 )
//                                             }
//                                         </span>
//                                     </label>
//                                     <div className="text-xs text-gray-500">
//                                         {sellStockForm.sellAmount && sellStockForm.sellUnits && parseFloat(sellStockForm.sellUnits) > 0
//                                             ? "Calculated as: selling amount ÷ units to sell"
//                                             : "Calculated as: (current_amount of stock ÷ total units) × units to sell"}
//                                     </div>
//                                     {sellStockForm.indirectCharges && parseFloat(sellStockForm.indirectCharges) > 0 && (
//                                         <div className="text-xs text-green-600 mt-1">
//                                             Indirect charges will also be recorded for this sale.
//                                         </div>
//                                     )}
//                                 </div>
//                             </form>
//                         </div>
//                         {/* Footer buttons, always visible */}
//                         <div className="flex gap-3 px-6 py-4 bg-gray-50 rounded-b-xl border-t border-gray-200">
//                             <button
//                                 type="button"
//                                 onClick={() => {
//                                     setShowSellStockModal(false);
//                                     setSellStockForm({
//                                         partyId: '',
//                                         category: '',
//                                         stockId: '',
//                                         stockName: '',
//                                         sellUnits: '',
//                                         sellAmount: '',
//                                         indirectCharges: '',
//                                         date: '',
//                                     });
//                                 }}
//                                 className="flex-1 bg-white border border-gray-300 text-gray-800 rounded-md py-2 font-medium hover:bg-gray-100 transition"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 type="submit"
//                                 form="sell-stock-form-modal"
//                                 disabled={sellStockLoading}
//                                 className="flex-1 bg-primary-600 text-white rounded-md py-2 font-medium hover:bg-primary-700 transition disabled:opacity-60"
//                                 style={{ background: "#1CAC70" }}
//                             >
//                                 {sellStockLoading ? "Saving..." : "Sell Stock"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             {/* ============ Withdrawal Modal & Form =========== */}
//             {showWithdrawalModal && (
//                 <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-40">
//                     <div className='bg-white rounded-2xl shadow-xl p-6 w-[90vw] max-w-[400px] flex flex-col gap-4'>
//                         <div className="flex justify-between items-center mb-2">
//                             <h2 className="text-lg font-semibold text-gray-800">Add Withdrawal</h2>
//                             <button
//                                 onClick={() => {
//                                     setShowWithdrawalModal(false);
//                                     resetWithdrawalForm();
//                                 }}
//                                 className="text-gray-400 hover:text-gray-700 text-xl font-bold"
//                                 aria-label="Close"
//                             >
//                                 ×
//                             </button>
//                         </div>
//                         <form onSubmit={handleWithdrawalSubmit} autoComplete="off">
//                             <div className='mb-2'>
//                                 <label htmlFor="withdrawal-partyId">Party Name</label>
//                                 <select
//                                     name="partyId"
//                                     id="withdrawal-partyId"
//                                     value={withdrawal.partyId}
//                                     onChange={handleWithdrawalInput}
//                                     required
//                                     className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                 >
//                                     <option value="">Choose Party</option>
//                                     {partiesList.map((p) => (
//                                         <option key={p.id} value={String(p.id)}>
//                                             {p.name}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className='mb-2'>
//                                 <label htmlFor="withdrawal-investmentType">Investment</label>
//                                 <select
//                                     name="withdrawalInvestmentType"
//                                     id="withdrawal-investmentType"
//                                     value={withdrawalInvestmentType}
//                                     onChange={handleWithdrawalInput}
//                                     required
//                                     className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                     disabled={!withdrawal.partyId}
//                                 >
//                                     <option value="direct">Direct Payment</option>
//                                     <option value="structure">Structure Payment</option>
//                                 </select>
//                             </div>
//                             {withdrawalInvestmentType === 'direct' && (
//                                 <div className='mb-2'>
//                                     <label htmlFor="withdrawal-directPayment">Payment Amount</label>
//                                     <input
//                                         type="number"
//                                         name="withdrawalDirectPayment"
//                                         id="withdrawal-directPayment"
//                                         placeholder="Enter payment amount"
//                                         value={withdrawalDirectPayment}
//                                         min={0}
//                                         onChange={e => setWithdrawalDirectPayment(e.target.value)}
//                                         className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                         required
//                                         disabled={!withdrawal.partyId}
//                                     />
//                                     <div className="mt-2">
//                                         <label htmlFor="withdrawal-date-direct">Date</label>
//                                         <input
//                                             type="date"
//                                             name="date"
//                                             id="withdrawal-date-direct"
//                                             value={withdrawal.date}
//                                             onChange={handleWithdrawalInput}
//                                             required
//                                             className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                             disabled={!withdrawal.partyId}
//                                         />
//                                     </div>
//                                 </div>
//                             )}
//                             {withdrawalInvestmentType === 'structure' && (
//                                 <>
//                                     <div className='mb-2'>
//                                         <label htmlFor="withdrawal-category">Category</label>
//                                         <select
//                                             name="category"
//                                             id="withdrawal-category"
//                                             value={withdrawal.category}
//                                             onChange={handleWithdrawalInput}
//                                             required
//                                             className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                             disabled={!withdrawal.partyId}
//                                         >
//                                             <option value="">Choose Category</option>
//                                             {withdrawCategoriesDb.map((cat) => (
//                                                 <option key={cat} value={cat}>{cat}</option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                     <div className='mb-2'>
//                                         <label htmlFor="withdrawal-stockName">Stock Name</label>
//                                         <select
//                                             name="stockName"
//                                             id="withdrawal-stockName"
//                                             value={withdrawal.stockName || ''}
//                                             onChange={handleWithdrawalInput}
//                                             required
//                                             className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                             disabled={!withdrawal.category}
//                                         >
//                                             <option value="">Select Stock</option>
//                                             {withdrawalStockOptions.map((item) => (
//                                                 <option key={item.id} value={item.stock_name}>
//                                                     {item.stock_name}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                     <div className='mb-2'>
//                                         <label htmlFor="withdrawal-amount">
//                                             Withdrawal Amount
//                                             {withdrawal.partyId && withdrawal.category && withdrawal.stockName && (
//                                                 <span className="text-xs text-blue-500 ml-2">
//                                                     (
//                                                     Available unit: {withdrawalUnitLimit}
//                                                     )
//                                                 </span>
//                                             )}
//                                         </label>
//                                         <input
//                                             type="number"
//                                             name="withdrawalAmount"
//                                             id="withdrawal-amount"
//                                             placeholder="Withdrawal Amount"
//                                             value={withdrawalDirectPayment}
//                                         min={0}
//                                         onChange={e => setWithdrawalDirectPayment(e.target.value)}
//                                             required
//                                             className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                             disabled={!withdrawal.stockName}
//                                         />
                                        
//                                     </div>
//                                     <div className='mb-2'>
//                                         <label htmlFor="withdrawal-date">Date</label>
//                                         <input
//                                             type="date"
//                                             name="date"
//                                             id="withdrawal-date"
//                                             value={withdrawal.date}
//                                             onChange={handleWithdrawalInput}
//                                             required
//                                             className='w-full border-[#D0D5DD] border-[1px] p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1'
//                                             disabled={!withdrawal.stockName}
//                                         />
//                                     </div>
//                                 </>
//                             )}
//                             <div className="flex gap-2 mt-6">
//                                 <button
//                                     type="submit"
//                                     disabled={withdrawalLoading}
//                                     className="bg-gradient-to-r from-[#1CAC70] to-[#FF9500] text-white px-6 py-2 rounded-lg font-semibold flex-1 disabled:opacity-60"
//                                 >
//                                     {withdrawalLoading ? "Saving..." : "Submit Withdrawal"}
//                                 </button>
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setShowWithdrawalModal(false);
//                                         resetWithdrawalForm();
//                                     }}
//                                     className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg font-semibold flex-1"
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default Addstock;

import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import * as XLSX from 'xlsx';
import parties from '../data/party';
import categoriesApi from '../data/categories';
import stockes from '../data/stockhistory';
import stockdata from '../data/stock';
import { fetchStocknames } from '../data/Stocknames';
import { fetchMutualnames } from '../data/Mutual';
import Select from "react-select";
import settingapi from '../data/setting';
import AsyncSelect from "react-select/async";
import OcrUploadModal from './OcrUploadModal';
// ─────────────────────────────────────────────────────────────────────────────
// TYPES
// ─────────────────────────────────────────────────────────────────────────────

interface Party {
  id: number;
  date: string;
  name: string;
  number: string;
  contact_person_name: string;
  contact_person_number: string;
  categories: string[];
  deleteparty: number;
  total_amount?: number | string;
}

interface CategoryApiType {
  id: number | string;
  category_name: string;
}

interface Stock {
  id: number | string;
  name: string;
  category: string;
}

interface StockNames {
  id: number;
  name: string;
  screener: string;
  ltp: string;
  [key: string]: any;
}

interface OcrSubmitInput {
    partyId: string | number;
    category: string;
    date: string;
    rows: Array<{
      id: string;
      stock_name: string;
      unit: string;
      total_amount: string;
      indirect_charges: string;
      per_unit_charge: string;
      confidence: 'high' | 'medium' | 'low';
      raw_text?: string;
      edited?: boolean;
      deleted?: boolean;
    }>;
  }

type StockCategoryInfo = {
  id: number | string;
  stockId: number | string;
  stockName: string;
  unit: string;
  totalAmount: string;
  indirectCharges: string;
  perUnitCharge: string;
  autoCalculated: boolean;
  category: string;
  error?: string;
};

type CategoryEntryMap = { [categoryName: string]: StockCategoryInfo[] };

type PartyStockDBType = {
  id: number | string;
  date: string;
  party_id: number | string;
  categories: string | (StockDBCategoryItem | DirectCategoryItem)[];
};

type StockDBCategoryItem = {
  id: number | string;
  investment_type: string;
  category: string;
  stock_name: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
};

type DirectCategoryItem = {
  investment_type: string;
  total_amount: string | number;
  date?: string;
  [key: string]: any;
};

// ─────────────────────────────────────────────────────────────────────────────
// EXCEL UPLOAD TYPES
// ─────────────────────────────────────────────────────────────────────────────

type ExcelRow = {
  stock_name: string;
  unit: string | number;
  total_amount: string | number;
  indirect_charges?: string | number;
  [key: string]: any;
};

type SheetData = {
  sheetName: string;
  fileName: string;
  fileIndex: number;
  rows: ExcelRow[];
};

type StockMatchStatus = 'matched' | 'fuzzy' | 'unmatched';

type ProcessedExcelRow = ExcelRow & {
  _rowId: string;
  _sheetKey: string;
  _matchStatus: StockMatchStatus;
  _matchedName?: string;
  _candidateMatches?: string[];
  _userChoice?: string; // after user resolves
  _addNew?: boolean;
  _newStockName?: string;
};

type ExcelUploadStep = 'idle' | 'setup' | 'review' | 'resolving' | 'confirmed';

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────

const safeNumber = (val: any) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : num;
};

let globalEntryId = 1;

function emptyStockCategoryInfo(category = '', stockId: number | string = '', stockName = ''): StockCategoryInfo {
  return {
    id: globalEntryId++,
    stockId,
    stockName,
    category,
    unit: '',
    totalAmount: '',
    indirectCharges: '',
    perUnitCharge: '',
    autoCalculated: true,
    error: undefined,
  };
}

function fuzzyMatch(name: string, list: string[]): string[] {
  const lower = name.toLowerCase().replace(/[^a-z0-9]/g, '');
  return list
    .filter(n => {
      const nl = n.toLowerCase().replace(/[^a-z0-9]/g, '');
      return nl.includes(lower) || lower.includes(nl) || levenshtein(lower, nl) <= 3;
    })
    .slice(0, 5);
}

function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++)
    for (let j = 1; j <= n; j++)
      dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
  return dp[m][n];
}

function calculateTotalDeductedIncludingDirect(stockDbRows: PartyStockDBType[], partyId: string | number): number {
  let total = 0;
  stockDbRows.forEach(row => {
    if (String(row.party_id) !== String(partyId)) return;
    let arr: any[] = [];
    try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
    for (const item of arr) {
      if (item?.investment_type === 'direct') total += safeNumber(item.total_amount);
      else if (item?.category) { total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges); }
    }
  });
  return total;
}

function calculateTotalDeductedFromStockTable(stockDbRows: PartyStockDBType[], partyId: string | number): number {
  let total = 0;
  stockDbRows.forEach(row => {
    if (String(row.party_id) !== String(partyId)) return;
    let arr: any[] = [];
    try { arr = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[]; } catch {}
    for (const item of arr) {
      if (item?.category) total += safeNumber(item.total_amount) + safeNumber(item.indirect_charges);
    }
  });
  return total;
}

async function fetchStocksAPI(): Promise<Stock[]> {
  return [
    { id: 1, name: 'SBI', category: 'Equity' },
    { id: 2, name: 'HDFC', category: 'Equity' },
    { id: 3, name: 'RELIANCE', category: 'Equity' },
    { id: 4, name: 'NIFTY-FUT', category: 'FNO' },
    { id: 5, name: 'BANKNIFTY-OPT', category: 'FNO' },
    { id: 6, name: 'ICICI MF', category: 'Mutual Funds' },
    { id: 7, name: 'SBI MF', category: 'Mutual Funds' },
    { id: 8, name: 'NIFTY ETF', category: 'ETF' },
    { id: 9, name: 'GOLD ETF', category: 'ETF' },
  ];
}



// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

interface Props {}
interface OcrExtractedRow {
    id: string;
    stock_name: string;
    unit: string;
    total_amount: string;
    indirect_charges: string;
    per_unit_charge: string;
    confidence: 'high' | 'medium' | 'low';
    raw_text?: string;
    edited?: boolean;
    deleted?: boolean;
    // NEW: per-row date from invoice
    row_date?: string;
  }
  
  interface OcrInvoice {
    invoice_no?: string;
    date?: string;
    rows: OcrExtractedRow[];
  }
  
  interface OcrResult {
    party_name?: string;
    category?: string;
    doc_type?: string;
    confidence_overall?: number;
    // NEW: multiple invoices instead of a single date + rows
    invoices: OcrInvoice[];
    // fallback for single-invoice docs
    date?: string;
    rows?: OcrExtractedRow[];
  }
  
  interface OcrFile {
    file: File;
    id: string;
    preview?: string;
    status: 'pending' | 'processing' | 'done' | 'error';
    result?: OcrResult;
    error?: string;
  }
  

function Addstock(props: Props) {
  // ── Core state ──────────────────────────────────────────────────────────────
  const [data, setData] = useState({ partyId: '', date: '' });
  const [investmentType, setInvestmentType] = useState<'direct' | 'structure'>('structure');
  const [directPaymentAmount, setDirectPaymentAmount] = useState('');
  const [categoryEntries, setCategoryEntries] = useState<CategoryEntryMap>({});
  const [partiesList, setPartiesList] = useState<Party[]>([]);
  const [allStocks, setAllStocks] = useState<Stock[]>([]);
  const [categoriesFromApi, setCategoriesFromApi] = useState<CategoryApiType[]>([]);
  const [stocksDb, setStocksDb] = useState<PartyStockDBType[]>([]);
  const [stocksDataDb, setStocksDataDb] = useState<PartyStockDBType[]>([]);
  const [urlParty, setUrlParty] = useState('');
  const [stocksnames, setStocksnames] = useState<StockNames[]>([]);
  const [mutualsnames, setMutualsnames] = useState<StockNames[]>([]);
  const [selectedPartyTotalAmount, setSelectedPartyTotalAmount] = useState<number | null>(null);
  const [deductedAvailable, setDeductedAvailable] = useState<number | null>(null);
  const [totalamountspend, setTotalAmmountSpend] = useState<number>();
  const [farmName, setFarmName] = useState<string>();
  const exceedPromptedRef = useRef(false);

  // ── Add-stock-name modal (Task 2) ────────────────────────────────────────────
  const [showAddStockModal, setShowAddStockModal] = useState(false);
  const [addStockModalCategory, setAddStockModalCategory] = useState<'stocks' | 'mutual'>('stocks');
  const [pendingNewStockName, setPendingNewStockName] = useState('');
  const [addStockLoading, setAddStockLoading] = useState(false);
  // Which entry triggered the add-stock modal (for injecting back)
  const addStockCallbackRef = useRef<((name: string) => void) | null>(null);

  // ── Excel upload state ───────────────────────────────────────────────────────
  const [excelUploadStep, setExcelUploadStep] = useState<ExcelUploadStep>('idle');
  const [excelSetupPartyId, setExcelSetupPartyId] = useState('');
  const [excelSetupCategory, setExcelSetupCategory] = useState('');
  const [excelSetupDate, setExcelSetupDate] = useState('');
  const [excelFiles, setExcelFiles] = useState<File[]>([]);
  const [parsedSheets, setParsedSheets] = useState<SheetData[]>([]);
  const [processedRows, setProcessedRows] = useState<{ [sheetKey: string]: ProcessedExcelRow[] }>({});
  const [currentResolvingSheet, setCurrentResolvingSheet] = useState<string | null>(null);
  const [currentResolvingRowId, setCurrentResolvingRowId] = useState<string | null>(null);
  const [excelSubmitLoading, setExcelSubmitLoading] = useState(false);
  const excelFileInputRef = useRef<HTMLInputElement>(null);

  const [showOcrModal, setShowOcrModal] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // DATA FETCHING
  // ─────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get('party') || '';
    setUrlParty(partyId);
    if (partyId) setData(prev => ({ ...prev, partyId }));
  }, []);

  const fetchParties = useCallback(async () => {
    const res = await parties();
    const cleaned = Array.isArray(res)
      ? res.map((item: any) => ({
          ...item,
          categories: typeof item.categories === 'string'
            ? (() => { try { const p = JSON.parse(item.categories); return Array.isArray(p) ? p : [item.categories]; } catch { return [item.categories]; } })()
            : Array.isArray(item.categories) ? item.categories : [],
          total_amount: item.total_amount !== undefined ? Number(item.total_amount) : undefined,
        }))
      : [];
    setPartiesList(cleaned);
  }, []);

  useEffect(() => {
    async function fetchSettingsApi() {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) {
          const s = res.find((i: any) => i.meta_key === 'farm');
          if (s?.meta_value) {
            const obj = typeof s.meta_value === 'string' ? JSON.parse(s.meta_value) : s.meta_value;
            if (typeof obj?.name === 'string') setFarmName(obj.name);
          }
        }
      } catch {}
    }
    fetchSettingsApi();
    fetchParties();
    categoriesApi().then(r => Array.isArray(r) && setCategoriesFromApi(r));
    fetchStocksAPI().then(s => setAllStocks(s));
    stockes().then(r => setStocksDb(Array.isArray(r) ? r : [])).catch(() => setStocksDb([]));
    stockdata().then(r => setStocksDataDb(Array.isArray(r) ? r : [])).catch(() => setStocksDataDb([]));
    fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : [])).catch(() => setStocksnames([]));
    fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : [])).catch(() => setMutualsnames([]));
  }, [fetchParties]);

  // ─────────────────────────────────────────────────────────────────────────────
  // DERIVED
  // ─────────────────────────────────────────────────────────────────────────────

  const possibleCategories = useMemo(() => {
    const activePartyId = data.partyId || urlParty;
    if (!activePartyId || !partiesList.length) return [];
    const party = partiesList.find(p => String(p.id) === String(activePartyId));
    if (party?.categories?.length) return party.categories.map((n: string) => ({ category_name: n, id: n }));
    return [];
  }, [partiesList, data.partyId, urlParty]);

  const excelSetupPossibleCategories = useMemo(() => {
    if (!excelSetupPartyId || !partiesList.length) return [];
    const party = partiesList.find(p => String(p.id) === String(excelSetupPartyId));
    if (party?.categories?.length) return party.categories;
    return [];
  }, [partiesList, excelSetupPartyId]);

  useEffect(() => {
    if (data.partyId && partiesList.length) {
      const party = partiesList.find(p => String(p.id) === String(data.partyId));
      setSelectedPartyTotalAmount(party?.total_amount != null ? Number(party.total_amount) : null);
    } else setSelectedPartyTotalAmount(null);
  }, [data.partyId, partiesList]);

  useEffect(() => {
    if (!selectedPartyTotalAmount) { setDeductedAvailable(null); return; }
    if (!data.partyId || !stocksDataDb.length) { setDeductedAvailable(selectedPartyTotalAmount); return; }
    const dbDeducted = calculateTotalDeductedIncludingDirect(stocksDataDb, data.partyId);
    let uiDeducted = 0;
    Object.values(categoryEntries).flat().forEach(e => {
      uiDeducted += safeNumber(e.totalAmount) + safeNumber(e.indirectCharges);
    });
    const result = selectedPartyTotalAmount - dbDeducted - uiDeducted;
    setDeductedAvailable(result);
    if (result < 0 && !exceedPromptedRef.current) {
      setTimeout(() => {
        const ok = window.confirm('You exceed your amount. Do you want to add it from margin money?');
        exceedPromptedRef.current = true;
        if (!ok) setDeductedAvailable(null);
      }, 100);
    }
  }, [selectedPartyTotalAmount, investmentType, directPaymentAmount, categoryEntries, data.partyId, stocksDataDb]);

  // ─────────────────────────────────────────────────────────────────────────────
  // CATEGORY / ENTRY HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  const isChecked = (cat: CategoryApiType) => Object.prototype.hasOwnProperty.call(categoryEntries, cat.category_name);

  const handleCategory = (cat: CategoryApiType) => {
    setCategoryEntries(prev => {
      const copy = { ...prev };
      if (copy[cat.category_name]) delete copy[cat.category_name];
      else copy[cat.category_name] = [emptyStockCategoryInfo(cat.category_name)];
      return copy;
    });
  };

  const handleCategoryFieldChange = (cat: CategoryApiType, entryIdx: number, field: keyof StockCategoryInfo, value: string) => {
    const category = cat.category_name;
    setCategoryEntries(prev => {
      const entries = [...(prev[category] || [])];
      const entry = { ...(entries[entryIdx] || emptyStockCategoryInfo(category)) };
      if (field === 'stockName') {
        entry.stockName = value;
        const s = allStocks.find(s => s.category === category && s.name.toLowerCase() === value.toLowerCase());
        entry.stockId = s ? s.id : value;
      } else if (field === 'stockId') {
        entry.stockId = value;
        const s = allStocks.find(s => s.category === category && String(s.id) === value);
        entry.stockName = s ? s.name : value;
      } else if (field === 'unit' || field === 'totalAmount' || field === 'indirectCharges') {
        (entry as any)[field] = value;
        const u = safeNumber(field === 'unit' ? value : entry.unit);
        const t = safeNumber(field === 'totalAmount' ? value : entry.totalAmount);
        const i = safeNumber(field === 'indirectCharges' ? value : entry.indirectCharges);
        entry.perUnitCharge = u > 0 ? ((t + i) / u).toFixed(2) : '';
        entry.autoCalculated = true;
      } else if (field === 'perUnitCharge') {
        entry.perUnitCharge = value;
        entry.autoCalculated = false;
      } else {
        (entry as any)[field] = value;
      }
      entries[entryIdx] = entry;
      return { ...prev, [category]: entries };
    });
  };

  const handleAddEntry = (cat: CategoryApiType) => {
    setCategoryEntries(prev => ({
      ...prev,
      [cat.category_name]: [...(prev[cat.category_name] || []), emptyStockCategoryInfo(cat.category_name)],
    }));
  };

  const handleRemoveEntry = (cat: CategoryApiType, idx: number) => {
    setCategoryEntries(prev => {
      const entries = [...(prev[cat.category_name] || [])];
      entries.splice(idx, 1);
      const copy = { ...prev };
      if (entries.length > 0) copy[cat.category_name] = entries;
      else delete copy[cat.category_name];
      return copy;
    });
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
    if (name === 'partyId') {
      setInvestmentType('structure');
      setCategoryEntries({});
      setDirectPaymentAmount('');
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // TASK 2: ADD STOCK NAME INLINE
  // ─────────────────────────────────────────────────────────────────────────────

  const isMutualCategory = (catName: string) =>
    catName.toLowerCase().includes('mutual');

  const handleAddStockName = async () => {
    if (!pendingNewStockName.trim()) { alert('Enter a stock name'); return; }
    setAddStockLoading(true);
    try {
      const endpoint = addStockModalCategory === 'mutual'
        ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
        : `${process.env.REACT_APP_API_URL}/auth/stocks`;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: pendingNewStockName.trim() }),
      });
      if (!res.ok) throw new Error('Failed to add stock');
      // Refresh stock lists
      if (addStockModalCategory === 'mutual') {
        fetchMutualnames().then(r => setMutualsnames(Array.isArray(r) ? r : []));
      } else {
        fetchStocknames().then(r => setStocksnames(Array.isArray(r) ? r : []));
      }
      // Inject name back into the entry that triggered this
      if (addStockCallbackRef.current) addStockCallbackRef.current(pendingNewStockName.trim());
      setShowAddStockModal(false);
      setPendingNewStockName('');
    } catch (err: any) {
      alert('Error: ' + err.message);
    } finally {
      setAddStockLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // EXCEL UPLOAD: PARSE
  // ─────────────────────────────────────────────────────────────────────────────

  const handleExcelFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setExcelFiles(prev => [...prev, ...files]);
  };

  const removeExcelFile = (idx: number) => {
    setExcelFiles(prev => prev.filter((_, i) => i !== idx));
  };

  const parseExcelFiles = async (): Promise<SheetData[]> => {
    const allSheets: SheetData[] = [];
    for (let fi = 0; fi < excelFiles.length; fi++) {
      const file = excelFiles[fi];
      const buffer = await file.arrayBuffer();
      const wb = XLSX.read(buffer, { type: 'array' });
      for (const sheetName of wb.SheetNames) {
        const ws = wb.Sheets[sheetName];
        const raw: any[] = XLSX.utils.sheet_to_json(ws, { defval: '' });
        // Normalize column names (lowercase, trim)
        const rows: ExcelRow[] = raw.map(r => {
          const norm: any = {};
          for (const k of Object.keys(r)) {
            norm[k.toLowerCase().trim().replace(/\s+/g, '_')] = r[k];
          }
          return {
            stock_name: String(norm.stock_name || norm.stockname || norm.name || norm['stock name'] || '').trim(),
            unit: norm.unit || norm.units || norm.qty || norm.quantity || '',
            total_amount: norm.total_amount || norm.totalamount || norm.amount || norm.price || '',
            indirect_charges: norm.indirect_charges || norm.indirectcharges || norm.charges || '0',
          } as ExcelRow;
        }).filter(r => r.stock_name);
        if (rows.length) {
          allSheets.push({ sheetName, fileName: file.name, fileIndex: fi, rows });
        }
      }
    }
    return allSheets;
  };

  const processSheets = (sheets: SheetData[], stockNameList: string[]) => {
    const result: { [sheetKey: string]: ProcessedExcelRow[] } = {};
    for (const sheet of sheets) {
      const key = `${sheet.fileIndex}__${sheet.fileName}__${sheet.sheetName}`;
      result[key] = sheet.rows.map((row, ri) => {
        const name = row.stock_name;
        const exact = stockNameList.find(n => n.toLowerCase() === name.toLowerCase());
        let matchStatus: StockMatchStatus;
        let matchedName: string | undefined;
        let candidates: string[] = [];
        if (exact) {
          matchStatus = 'matched';
          matchedName = exact;
        } else {
          candidates = fuzzyMatch(name, stockNameList);
          matchStatus = candidates.length ? 'fuzzy' : 'unmatched';
        }
        return {
          ...row,
          _rowId: `${key}__${ri}`,
          _sheetKey: key,
          _matchStatus: matchStatus,
          _matchedName: matchedName,
          _candidateMatches: candidates,
          _userChoice: matchedName,
          _addNew: false,
          _newStockName: '',
        } as ProcessedExcelRow;
      });
    }
    return result;
  };

  const handleExcelProceed = async () => {
    if (!excelSetupPartyId) { alert('Select a party'); return; }
    if (!excelSetupCategory) { alert('Select a category'); return; }
    if (!excelSetupDate) { alert('Select a date'); return; }
    if (!excelFiles.length) { alert('Upload at least one Excel file'); return; }

    const sheets = await parseExcelFiles();
    if (!sheets.length) { alert('No valid rows found. Check column names: stock_name, unit, total_amount'); return; }

    const isMutual = isMutualCategory(excelSetupCategory);
    const nameList = (isMutual ? mutualsnames : stocksnames).map(s => s.name);
    const processed = processSheets(sheets, nameList);

    setParsedSheets(sheets);
    setProcessedRows(processed);
    setExcelUploadStep('review');
  };

  // Rows that need resolution (fuzzy or unmatched)
  const unresolvedRows = useMemo(() => {
    const rows: ProcessedExcelRow[] = [];
    for (const sheetRows of Object.values(processedRows)) {
      for (const row of sheetRows) {
        if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) rows.push(row);
      }
    }
    return rows;
  }, [processedRows]);

  const updateProcessedRow = (sheetKey: string, rowId: string, patch: Partial<ProcessedExcelRow>) => {
    setProcessedRows(prev => ({
      ...prev,
      [sheetKey]: prev[sheetKey].map(r => r._rowId === rowId ? { ...r, ...patch } : r),
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // EXCEL SUBMIT
  // ─────────────────────────────────────────────────────────────────────────────

  const handleExcelSubmit = async () => {
    setExcelSubmitLoading(true);
    try {
      const isMutual = isMutualCategory(excelSetupCategory);

      // 1. Add new stock names first
      const rowsToAddAsNewStock: ProcessedExcelRow[] = [];
      for (const sheetRows of Object.values(processedRows)) {
        for (const row of sheetRows) {
          if (row._addNew && row._newStockName?.trim()) rowsToAddAsNewStock.push(row);
        }
      }
      const addedNames: Set<string> = new Set();
      for (const row of rowsToAddAsNewStock) {
        const nm = row._newStockName!.trim();
        if (addedNames.has(nm)) continue;
        addedNames.add(nm);
        const ep = isMutual
          ? `${process.env.REACT_APP_API_URL}/auth/mutualstocks`
          : `${process.env.REACT_APP_API_URL}/auth/stocks`;
        await fetch(ep, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: nm }),
        });
      }

      // 2. Group rows by sheet and submit each sheet's rows as separate entries
      for (const [sheetKey, sheetRows] of Object.entries(processedRows)) {
        const validRows = sheetRows.filter(r => {
          const finalName = r._addNew ? r._newStockName : (r._userChoice || r._matchedName || r.stock_name);
          return finalName?.trim();
        });
        if (!validRows.length) continue;

        // Build categories array for this sheet
        const cats = validRows.map((row, i) => {
          const finalName = (row._addNew ? row._newStockName : (row._userChoice || row._matchedName || row.stock_name)) || '';
          const unit = String(row.unit || '0');
          const total = String(row.total_amount || '0');
          const indirect = String(row.indirect_charges || '0');
          const u = safeNumber(unit), t = safeNumber(total), ind = safeNumber(indirect);
          return {
            id: globalEntryId++,
            stock_name: finalName,
            unit,
            total_amount: total,
            indirect_charges: indirect,
            perUnitCharge: u > 0 ? ((t + ind) / u).toFixed(2) : '0',
            category: excelSetupCategory,
            investment_type: 'structure',
            total_amount_category: total,
          };
        });

        // Check for existing stocks -> PUT, new -> POST
        const rowUpdates = new Map<any, any>();
        const newCats: any[] = [];
        let grandTotal = 0;

        for (const cat of cats) {
          grandTotal += safeNumber(cat.total_amount) + safeNumber(cat.indirect_charges);
          const existingRow = stocksDataDb.find(row => {
            if (String(row.party_id) !== String(excelSetupPartyId)) return false;
            const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
            return items.some(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
          });
          if (existingRow) {
            const arr: any[] = typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]];
            const target = arr.find(i => i.stock_name === cat.stock_name && i.category === excelSetupCategory);
            if (target) {
              const tu = safeNumber(target.unit) + safeNumber(cat.unit);
              const ta = safeNumber(target.total_amount) + safeNumber(cat.total_amount);
              const ti = safeNumber(target.indirect_charges) + safeNumber(cat.indirect_charges);
              target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString();
              target.perUnitCharge = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0';
              rowUpdates.set(existingRow.id, { arr, lastName: cat.stock_name, lastCat: excelSetupCategory, lastUnit: tu.toString(), lastTotal: ta.toString(), lastIndirect: ti.toString(), lastPrice: target.perUnitCharge });
            }
          } else {
            newCats.push(cat);
          }
        }

        // PUT existing
        for (const [rowId, obj] of rowUpdates.entries()) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: rowId, party_id: excelSetupPartyId,
              categories: JSON.stringify(obj.arr),
              name: obj.lastName, category: obj.lastCat,
              unit: obj.lastUnit, price_per_unit: obj.lastPrice,
              total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect,
              date: excelSetupDate,
            }),
          });
        }

        // POST new
        if (newCats.length) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ party_id: excelSetupPartyId, date: excelSetupDate, investment_type: 'structure', categories: newCats }),
          });
        }

        // buysellrecord + usermeta
        await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ date: excelSetupDate, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
        }).catch(() => {});

        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${excelSetupPartyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(excelSetupPartyId)) : null;
        if (found) {
          const newVal = (safeNumber(found.meta_value) - grandTotal).toString();
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
            method: 'PUT', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ meta_key: 'remaining', meta_value: newVal, party_id: excelSetupPartyId }),
          });
        }
      }

      alert('Excel data submitted successfully!');
      setExcelUploadStep('idle');
      setParsedSheets([]);
      setProcessedRows({});
      setExcelFiles([]);
      setExcelSetupPartyId('');
      setExcelSetupCategory('');
      setExcelSetupDate('');
      window.location.reload();
    } catch (err: any) {
      alert('Error: ' + err.message);
    } finally {
      setExcelSubmitLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // MAIN SUBMIT
  // ─────────────────────────────────────────────────────────────────────────────

  const getNextCategoryId = () => {
    const ids: number[] = [];
    stocksDataDb.forEach(row => {
      const items = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories;
      (items as any[]).forEach(i => i.id && ids.push(Number(i.id)));
    });
    return (ids.length ? Math.max(...ids) : 0) + 1;
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!data.partyId) { alert('Please select a party'); return; }
    const party = partiesList.find(p => String(p.id) === String(data.partyId));
    const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
    if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
    const currentInvestmentType = investmentType;
    const selectedCategories = Object.keys(categoryEntries);
    if (selectedCategories.length === 0) { alert('Please select at least one category'); return; }

    const rowUpdates = new Map<any, any>();
    let categoriesToPost: any[] = [];
    let grandTotal = 0;
    let datainvoiceAll: any[] = [];

    for (const categoryName of selectedCategories) {
      const entries = categoryEntries[categoryName];
      for (const catInfo of entries) {
        if (!catInfo.stockName?.trim()) continue;
        const amt = safeNumber(catInfo.totalAmount), ind = safeNumber(catInfo.indirectCharges);
        grandTotal += amt + ind;
        datainvoiceAll.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
        const existingRow = stocksDataDb.find(row => {
          if (String(row.party_id) !== String(data.partyId)) return false;
          const items: any[] = typeof row.categories === 'string' ? JSON.parse(row.categories) : row.categories as any[];
          return items.some(i => i.stock_name === catInfo.stockName && i.category === categoryName);
        });
        if (existingRow) {
          const arr: any[] = rowUpdates.has(existingRow.id) ? rowUpdates.get(existingRow.id).updatedCategories : (typeof existingRow.categories === 'string' ? JSON.parse(existingRow.categories) : [...existingRow.categories as any[]]);
          const target = arr.find((i: any) => i.stock_name === catInfo.stockName && i.category === categoryName);
          if (target) {
            const tu = safeNumber(target.unit) + safeNumber(catInfo.unit);
            const ta = safeNumber(target.total_amount) + amt;
            const ti = safeNumber(target.indirect_charges) + ind;
            const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
            target.unit = tu.toString(); target.total_amount = ta.toString(); target.indirect_charges = ti.toString(); target.perUnitCharge = avgP; target.total_amount_category = ta.toString(); target.investment_type = currentInvestmentType;
            rowUpdates.set(existingRow.id, { updatedCategories: arr, lastCatId: catInfo.id, lastName: catInfo.stockName, lastCategory: categoryName, lastUnit: tu.toString(), lastPrice: avgP, lastTotal: ta.toString(), lastIndirect: ti.toString() });
          }
        } else {
          categoriesToPost.push({ id: catInfo.id, stock_name: catInfo.stockName, unit: catInfo.unit, total_amount: catInfo.totalAmount, indirect_charges: catInfo.indirectCharges ?? '0', perUnitCharge: catInfo.perUnitCharge, category: categoryName, investment_type: currentInvestmentType, total_amount_category: catInfo.totalAmount });
        }
      }
    }

    if (typeof setTotalAmmountSpend === 'function') setTotalAmmountSpend(grandTotal);

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ date: data.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }) });
    } catch {}
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ farm: farmName, party: data.partyId, invoice_type: 'purchase', date: data.date, datainvoice: datainvoiceAll }) });
    } catch {}

    const handleUserMetaUpdate = async (amount: number) => {
      try {
        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${data.partyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList) ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(data.partyId)) : null;
        if (found) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: (safeNumber(found.meta_value) - amount).toString(), party_id: data.partyId }) });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ meta_key: 'remaining', meta_value: ((availableTotalAmount || 0) - amount).toString(), party_id: data.partyId }) });
        }
      } catch {}
    };

    if (investmentType === 'direct') {
      const payment = safeNumber(directPaymentAmount);
      if (payment <= 0) { alert('Please enter valid payment amount'); return; }
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: 'direct', categories: [{ id: getNextCategoryId(), stock_name: 'DirectPayment', unit: '0', total_amount: payment.toString(), category: 'Equity', indirect_charges: '0', perUnitCharge: '0', investment_type: 'direct', total_amount_category: payment.toString() }] }) });
        await handleUserMetaUpdate(payment);
        alert('Direct payment submitted'); window.location.reload(); return;
      } catch (err) { alert('Error in direct payment'); return; }
    }

    try {
      for (const [rowId, obj] of rowUpdates.entries()) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rowId, party_id: data.partyId, categories: JSON.stringify(obj.updatedCategories), name: obj.lastName, category: obj.lastCategory, unit: obj.lastUnit, price_per_unit: obj.lastPrice, total_amount: obj.lastTotal, indirect_charges: obj.lastIndirect, investment_type: currentInvestmentType, date: data.date || new Date().toISOString().split('T')[0] }) });
      }
      if (categoriesToPost.length) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ party_id: data.partyId, date: data.date, investment_type: currentInvestmentType, categories: categoriesToPost }) });
      }
      await handleUserMetaUpdate(grandTotal);
      alert('Submission successful'); window.location.reload();
    } catch { alert('An error occurred during submission.'); }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER HELPERS
  // ─────────────────────────────────────────────────────────────────────────────

  const renderMatchBadge = (status: StockMatchStatus) => {
    if (status === 'matched') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">✓ Matched</span>;
    if (status === 'fuzzy') return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">⚠ Fuzzy</span>;
    return <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">✗ Not Found</span>;
  };

  const allRowsResolved = useMemo(() => {
    for (const sheetRows of Object.values(processedRows)) {
      for (const row of sheetRows) {
        if (row._matchStatus !== 'matched' && !row._userChoice && !row._addNew) return false;
      }
    }
    return true;
  }, [processedRows]);

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────────


  const handleOcrSubmit = async ({ partyId, category, batches }: {
    partyId: string;
    category: string;
    batches: { date: string; rows: OcrExtractedRow[] }[];
  }): Promise<void> => {
    if (!partyId) { alert('Please select a party'); return; }
    if (!category) { alert('Please select a category'); return; }
  
    const party = partiesList.find(p => String(p.id) === String(partyId));
    const availableTotalAmount = party?.total_amount != null ? Number(party.total_amount) : null;
    if (availableTotalAmount == null) { alert('Could not determine total amount available.'); return; }
  
    for (const batch of batches) {
      if (!batch.date) continue;
      const validRows = batch.rows.filter(r => r.stock_name?.trim());
      if (!validRows.length) continue;
  
      const rowUpdates = new Map<any, any>();
      const categoriesToPost: any[] = [];
      let grandTotal = 0;
      const datainvoiceAll: any[] = [];
  
      for (const row of validRows) {
        const amt = safeNumber(row.total_amount);
        const ind = safeNumber(row.indirect_charges);
        grandTotal += amt + ind;
  
        datainvoiceAll.push({
          id: row.id,
          stock_name: row.stock_name,
          unit: row.unit,
          total_amount: row.total_amount,
          indirect_charges: row.indirect_charges ?? '0',
          perUnitCharge: row.per_unit_charge,
          category,
          investment_type: 'structure',
          total_amount_category: row.total_amount,
        });
  
        // Check if stock already exists in DB for this party+category
        const existingRow = stocksDataDb.find(dbRow => {
          if (String(dbRow.party_id) !== String(partyId)) return false;
          const items: any[] = typeof dbRow.categories === 'string'
            ? JSON.parse(dbRow.categories)
            : dbRow.categories as any[];
          return items.some(i => i.stock_name === row.stock_name && i.category === category);
        });
  
        if (existingRow) {
          // PUT — merge into existing
          const arr: any[] = rowUpdates.has(existingRow.id)
            ? rowUpdates.get(existingRow.id).updatedCategories
            : (typeof existingRow.categories === 'string'
              ? JSON.parse(existingRow.categories)
              : [...existingRow.categories as any[]]);
  
          const target = arr.find((i: any) => i.stock_name === row.stock_name && i.category === category);
          if (target) {
            const tu = safeNumber(target.unit) + safeNumber(row.unit);
            const ta = safeNumber(target.total_amount) + amt;
            const ti = safeNumber(target.indirect_charges) + ind;
            const avgP = tu > 0 ? ((ta + ti) / tu).toFixed(2) : '0.00';
            target.unit = tu.toString();
            target.total_amount = ta.toString();
            target.indirect_charges = ti.toString();
            target.perUnitCharge = avgP;
            target.total_amount_category = ta.toString();
            target.investment_type = 'structure';
            rowUpdates.set(existingRow.id, {
              updatedCategories: arr,
              lastName: row.stock_name,
              lastCategory: category,
              lastUnit: tu.toString(),
              lastPrice: avgP,
              lastTotal: ta.toString(),
              lastIndirect: ti.toString(),
            });
          }
        } else {
          // POST — new entry
          categoriesToPost.push({
            id: row.id,
            stock_name: row.stock_name,
            unit: row.unit,
            total_amount: row.total_amount,
            indirect_charges: row.indirect_charges ?? '0',
            perUnitCharge: row.per_unit_charge,
            category,
            investment_type: 'structure',
            total_amount_category: row.total_amount,
          });
        }
      }
  
      // ── buysellrecord ──────────────────────────────────────────────────────
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/buysellrecord`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ date: batch.date, totalpurchase: grandTotal, totalsell: 0, closingBLC: 0 }),
        });
      } catch {}
  
      // ── invoice record ─────────────────────────────────────────────────────
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/invoice`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            farm: farmName,
            party: partyId,
            invoice_type: 'purchase',
            date: batch.date,
            datainvoice: datainvoiceAll,
          }),
        });
      } catch {}
  
      // ── PUT existing stocks ────────────────────────────────────────────────
      for (const [rowId, obj] of rowUpdates.entries()) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: rowId,
            party_id: partyId,
            categories: JSON.stringify(obj.updatedCategories),
            name: obj.lastName,
            category: obj.lastCategory,
            unit: obj.lastUnit,
            price_per_unit: obj.lastPrice,
            total_amount: obj.lastTotal,
            indirect_charges: obj.lastIndirect,
            investment_type: 'structure',
            date: batch.date,
          }),
        });
      }
  
      // ── POST new stocks ────────────────────────────────────────────────────
      if (categoriesToPost.length) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/addstocks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            party_id: partyId,
            date: batch.date,
            investment_type: 'structure',
            categories: categoriesToPost,
          }),
        });
      }
  
      // ── usermeta (remaining balance) ───────────────────────────────────────
      try {
        const umRes = await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta?party_id=${partyId}`);
        const umList = await umRes.json();
        const found = Array.isArray(umList)
          ? umList.find((m: any) => m.meta_key === 'remaining' && String(m.party_id) === String(partyId))
          : null;
        if (found) {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta/${found.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: (safeNumber(found.meta_value) - grandTotal).toString(),
              party_id: partyId,
            }),
          });
        } else {
          await fetch(`${process.env.REACT_APP_API_URL}/auth/updateusermeta`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              meta_key: 'remaining',
              meta_value: ((availableTotalAmount || 0) - grandTotal).toString(),
              party_id: partyId,
            }),
          });
        }
      } catch {}
    }
  
    await fetchParties();
    setShowOcrModal(false);
  };
  return (
    <>
      <div className="p-6">
        {/* ── Header ── */}
        <div className="w-full flex justify-between items-center mb-6">
          <h1 className="text-[28px] text-[#101828] font-[500]">Add New Stock</h1>
          <div className="flex gap-3">
          <button
            type="button"
            onClick={() => setShowOcrModal(true)}
            className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] py-2 px-5 rounded-[8px] shadow hover:opacity-90 transition duration-150"
          >
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
                fill="#fff"
                fillOpacity=".1"
              />
              <path
                d="M8 2v4M16 2v4M3 10h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle
                cx="12"
                cy="14"
                r="3"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
            Scan Document
          </button>
   {showOcrModal ? (
  <OcrUploadModal
  partiesList={partiesList}
  stocksnames={stocksnames}
  mutualsnames={mutualsnames}
  onSubmit={handleOcrSubmit as any}
  onClose={() => setShowOcrModal(false)}
  apiUrl={process.env.REACT_APP_API_URL || ''}
/>
   ) : null}
            <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/withdraw'}>Add Withdrawal</button>
            <button type="button" className="flex items-center gap-2 text-[14px] font-[500] text-white bg-gradient-to-r from-[#FF9500] to-[#1CAC70] py-2 rounded-[8px] px-5" onClick={() => window.location.href = '/sell-stock'}>Sell Stock</button>
          </div>
        </div>

        {/* ── Manual Form ── */}
        <form className="bg-white p-5 w-full rounded-[10px] shadow-sm" onSubmit={handleSubmit} autoComplete="off">
          <div className="flex flex-wrap w-full justify-between mt-4 gap-4">
            {/* Party */}
            <div className="w-[100%] md:w-[48%]">
              <label htmlFor="partyId" className="text-sm font-medium text-gray-700">Party Name</label>
              <select name="partyId" id="partyId" value={data.partyId || urlParty} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required>
                <option value="">Choose Party</option>
                {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
              </select>
              {selectedPartyTotalAmount !== null && <div className="text-xs text-blue-600 mt-1">Total Available: ₹{selectedPartyTotalAmount.toLocaleString()}</div>}
              {deductedAvailable !== null && <div className="text-xs mt-1" style={{ color: deductedAvailable < 0 ? '#D8000C' : '#007200' }}>Available After Deduction: ₹{deductedAvailable.toLocaleString()}</div>}
            </div>
            {/* Date */}
            <div className="w-[100%] md:w-[48%]">
              <label htmlFor="date" className="text-sm font-medium text-gray-700">Date Of Purchase</label>
              <input type="date" name="date" id="date" value={data.date} onChange={handleInput} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" />
            </div>
            {/* Investment Type */}
            <div className="w-[100%] md:w-[48%]">
              <label className="text-sm font-medium text-gray-700">Investment Type</label>
              <select value={investmentType} onChange={e => { setInvestmentType(e.target.value as any); setDirectPaymentAmount(''); setCategoryEntries({}); }} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1">
                <option value="direct">Direct Payment</option>
                <option value="structure">Structure Payment</option>
              </select>
            </div>
          </div>

          {investmentType === 'direct' && (
            <div className="mt-4 w-full md:w-[48%]">
              <label className="text-sm font-medium text-gray-700">Payment Amount</label>
              <input type="number" min={0} step="any" placeholder="Enter payment amount" value={directPaymentAmount} onChange={e => setDirectPaymentAmount(e.target.value)} className="w-full border-[#D0D5DD] border p-2 rounded-[8px] text-[#667085] text-[16px] outline-none mt-1" required />
            </div>
          )}

          {/* Categories */}
          {(data.partyId || urlParty) && (
            <div className="mt-6">
              <p className="text-sm font-semibold text-gray-700 mb-3">Categories</p>
              <div className="flex flex-col gap-3">
                {possibleCategories.map(cat => {
                  const entries = categoryEntries[cat.category_name] || [];
                  const isMutual = isMutualCategory(cat.category_name);
                  return (
                    <div key={cat.id} className="flex flex-col">
                      <label className="flex items-center gap-2 cursor-pointer text-[#344054] text-[15px] font-medium">
                        <input type="checkbox" checked={isChecked(cat)} onChange={() => handleCategory(cat)} className="w-4 h-4 accent-[#FF9500]" />
                        {cat.category_name}
                      </label>
                      {isChecked(cat) && investmentType === 'structure' && (
                        <div className="ml-6 mt-2 flex flex-col gap-3 border-l-2 border-[#ececec] pl-4">
                          {entries.map((entry, ei) => (
                            <div key={entry.id} className="flex flex-wrap gap-2 items-end bg-gray-50 p-3 rounded-lg relative">
                              {/* ID */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">ID</label>
                                <input type="text" value={entry.id} readOnly className="w-[52px] bg-gray-100 border border-[#D0D5DD] p-2 rounded-[8px] text-[#5E5E5E] text-[12px] outline-none" />
                              </div>
                              {/* Stock Name with AsyncSelect + Add button */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Stock Name</label>
                                <div className="flex gap-1 items-center">
                                  <AsyncSelect
                                    cacheOptions
                                    defaultOptions={false}
                                    loadOptions={(input, cb) => {
                                      if (!input || input.length < 1) { cb([]); return; }
                                      const src = isMutual ? mutualsnames : stocksnames;
                                      const filtered = src.filter(s => s.name?.toLowerCase().includes(input.toLowerCase())).slice(0, 100).map(s => ({ value: s.name, label: s.name }));
                                      cb(filtered);
                                    }}
                                    value={entry.stockName ? { value: entry.stockName, label: entry.stockName } : null}
                                    onChange={sel => handleCategoryFieldChange(cat, ei, 'stockName', sel?.value || '')}
                                    placeholder={isMutual ? 'Search Mutual Fund...' : 'Search Stock...'}
                                    noOptionsMessage={({ inputValue }) =>
                                      inputValue?.length > 0
                                        ? <span className="text-xs text-gray-500">No match — type to search or use "+" to add</span>
                                        : <span className="text-xs text-gray-400">Type to search…</span>
                                    }
                                    styles={{ control: (b) => ({ ...b, borderRadius: '8px', borderColor: '#D0D5DD', minHeight: '38px', width: '210px', fontSize: '13px' }) }}
                                  />
                                  {/* Task 2: Add stock button */}
                                  <button
                                    type="button"
                                    title="Add new stock name"
                                    onClick={() => {
                                      setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
                                      setPendingNewStockName(entry.stockName || '');
                                      addStockCallbackRef.current = (name: string) => {
                                        handleCategoryFieldChange(cat, ei, 'stockName', name);
                                      };
                                      setShowAddStockModal(true);
                                    }}
                                    className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 transition font-bold text-lg"
                                    style={{ flexShrink: 0 }}
                                  >
                                    +
                                  </button>
                                </div>
                                {entry.stockName && !(isMutual ? mutualsnames : stocksnames).some(s => s.name.toLowerCase() === entry.stockName.toLowerCase()) && (
                                  <span className="text-[10px] text-amber-600 mt-0.5 flex items-center gap-1">
                                    ⚠ Not in database —
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setAddStockModalCategory(isMutual ? 'mutual' : 'stocks');
                                        setPendingNewStockName(entry.stockName);
                                        addStockCallbackRef.current = (name: string) => handleCategoryFieldChange(cat, ei, 'stockName', name);
                                        setShowAddStockModal(true);
                                      }}
                                      className="underline text-blue-600 hover:text-blue-800"
                                    >
                                      Add to database?
                                    </button>
                                  </span>
                                )}
                              </div>
                              {/* Unit */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Unit</label>
                                <input type="number" min={0} step="any" placeholder="Unit" value={entry.unit} onChange={e => handleCategoryFieldChange(cat, ei, 'unit', e.target.value)} className="w-[100px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Total Amount */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Total Amount</label>
                                <input type="number" min={0} step="any" placeholder="Amount" value={entry.totalAmount} onChange={e => handleCategoryFieldChange(cat, ei, 'totalAmount', e.target.value)} className="w-[120px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Indirect Charges */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Indirect Charges</label>
                                <input type="number" min={0} step="any" placeholder="Charges" value={entry.indirectCharges} onChange={e => handleCategoryFieldChange(cat, ei, 'indirectCharges', e.target.value)} className="w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none" required />
                              </div>
                              {/* Per Unit Charge */}
                              <div className="flex flex-col">
                                <label className="text-[11px] text-gray-500">Per Unit Charge</label>
                                <input type="number" min={0} step="any" placeholder="Per unit" value={entry.perUnitCharge} onChange={e => handleCategoryFieldChange(cat, ei, 'perUnitCharge', e.target.value)} readOnly={entry.autoCalculated && !!entry.unit} className={`w-[110px] border border-[#D0D5DD] p-2 rounded-[8px] text-[#667085] text-[12px] outline-none ${entry.autoCalculated && !!entry.unit ? 'bg-gray-100' : ''}`} required />
                                {entry.autoCalculated && !!entry.unit && <span className="text-[10px] text-green-500">Auto-calc</span>}
                              </div>
                              {/* Remove */}
                              <button type="button" onClick={() => handleRemoveEntry(cat, ei)} className="text-red-400 hover:text-red-600 border border-red-200 bg-red-50 rounded px-2 py-1 text-xs h-[34px]">Remove</button>
                            </div>
                          ))}
                          <button type="button" onClick={() => handleAddEntry(cat)} className="text-sm text-blue-500 font-medium px-3 py-1 border border-blue-200 rounded bg-blue-50 w-fit hover:bg-blue-100 transition">+ Add row for {cat.category_name}</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <button type="submit" className="mt-6 text-[16px] font-[500] text-white bg-gradient-to-r from-[#1CAC70] to-[#FF9500] py-2 rounded-[8px] px-8 hover:opacity-90 transition">Submit</button>
        </form>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════════
          EXCEL UPLOAD MODAL — STEP: SETUP
      ══════════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'setup' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Upload Excel Data</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 1 of 2 — Configure import settings</p>
                </div>
                <button onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
            </div>

            <div className="p-6 flex flex-col gap-4">
              {/* Party */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Party Name <span className="text-red-500">*</span></label>
                <select value={excelSetupPartyId} onChange={e => { setExcelSetupPartyId(e.target.value); setExcelSetupCategory(''); }} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400">
                  <option value="">Choose Party</option>
                  {partiesList.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
                </select>
              </div>
              {/* Category */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Category <span className="text-red-500">*</span></label>
                <select value={excelSetupCategory} onChange={e => setExcelSetupCategory(e.target.value)} disabled={!excelSetupPartyId} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400 disabled:bg-gray-100">
                  <option value="">Select Category</option>
                  {excelSetupPossibleCategories.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              {/* Date */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Purchase Date <span className="text-red-500">*</span></label>
                <input type="date" value={excelSetupDate} onChange={e => setExcelSetupDate(e.target.value)} className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-indigo-400" />
              </div>

              {/* File Upload */}
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-2">Excel Files <span className="text-red-500">*</span></label>
                <div
                  className="border-2 border-dashed border-indigo-200 rounded-xl p-6 text-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition"
                  onClick={() => excelFileInputRef.current?.click()}
                >
                  <div className="text-3xl mb-2">📊</div>
                  <p className="text-sm text-gray-600 font-medium">Click to browse or drop Excel files here</p>
                  <p className="text-xs text-gray-400 mt-1">Supports .xlsx, .xls — multiple files allowed, all sheets imported</p>
                  <p className="text-xs text-indigo-500 mt-1 font-medium">Required columns: <code className="bg-indigo-50 px-1 rounded">stock_name</code>, <code className="bg-indigo-50 px-1 rounded">unit</code>, <code className="bg-indigo-50 px-1 rounded">total_amount</code></p>
                </div>
                <input ref={excelFileInputRef} type="file" accept=".xlsx,.xls" multiple className="hidden" onChange={handleExcelFilesChange} />
                {excelFiles.length > 0 && (
                  <div className="mt-3 flex flex-col gap-1.5">
                    {excelFiles.map((f, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
                        <div className="flex items-center gap-2">
                          <span className="text-green-500">📄</span>
                          <span className="text-sm text-gray-700 font-medium">{f.name}</span>
                          <span className="text-xs text-gray-400">({(f.size / 1024).toFixed(1)} KB)</span>
                        </div>
                        <button type="button" onClick={() => removeExcelFile(i)} className="text-red-400 hover:text-red-600 text-lg leading-none">×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="flex gap-3 mt-2">
                <button type="button" onClick={() => { setExcelUploadStep('idle'); setExcelFiles([]); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2.5 font-medium hover:bg-gray-50 transition">Cancel</button>
                <button type="button" onClick={handleExcelProceed} className="flex-1 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white rounded-lg py-2.5 font-medium hover:opacity-90 transition">Preview & Review →</button>
              </div>
            </div>
          </div>
        </div>
      )}
     

      {/* ══════════════════════════════════════════════════════════════════════════
          EXCEL UPLOAD MODAL — STEP: REVIEW
      ══════════════════════════════════════════════════════════════════════════ */}
      {excelUploadStep === 'review' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl mx-4 flex flex-col" style={{ maxHeight: '90vh' }}>
            {/* Header */}
            <div className="bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] px-6 py-5 rounded-t-2xl flex-shrink-0">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-bold text-white">Review Import Data</h2>
                  <p className="text-indigo-200 text-sm mt-0.5">Step 2 of 2 — Verify stock matches and resolve conflicts</p>
                </div>
                <button onClick={() => setExcelUploadStep('setup')} className="text-white/70 hover:text-white text-2xl">×</button>
              </div>
              {/* Summary bar */}
              <div className="flex gap-4 mt-3">
                {(() => {
                  let matched = 0, fuzzy = 0, unmatched = 0;
                  Object.values(processedRows).flat().forEach(r => {
                    if (r._matchStatus === 'matched') matched++;
                    else if (r._matchStatus === 'fuzzy') fuzzy++;
                    else unmatched++;
                  });
                  const total = matched + fuzzy + unmatched;
                  return (
                    <>
                      <div className="bg-white/20 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{total}</span> total rows</div>
                      <div className="bg-green-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{matched}</span> matched</div>
                      {fuzzy > 0 && <div className="bg-yellow-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{fuzzy}</span> fuzzy</div>}
                      {unmatched > 0 && <div className="bg-red-500/30 rounded-lg px-3 py-1.5 text-white text-sm"><span className="font-bold">{unmatched}</span> not found</div>}
                    </>
                  );
                })()}
              </div>
            </div>

            {/* Content */}
            <div className="overflow-y-auto flex-1 p-6">
              {Object.entries(processedRows).map(([sheetKey, rows]) => {
                const parts = sheetKey.split('__');
                const fileName = parts[1], sheetName = parts[2];
                return (
                  <div key={sheetKey} className="mb-8">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="bg-indigo-100 text-indigo-700 rounded-lg px-3 py-1 text-sm font-semibold">📄 {fileName}</div>
                      <div className="bg-gray-100 text-gray-600 rounded-lg px-3 py-1 text-sm">Sheet: {sheetName}</div>
                      <div className="text-xs text-gray-400">{rows.length} rows</div>
                    </div>
                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">#</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Excel Stock Name</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Status</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Final Name</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Unit</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Amount</th>
                            <th className="text-left px-4 py-3 text-gray-600 font-medium">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((row, ri) => (
                            <tr key={row._rowId} className={`border-t border-gray-100 ${row._matchStatus === 'matched' ? 'bg-green-50/30' : row._matchStatus === 'fuzzy' ? 'bg-yellow-50/30' : 'bg-red-50/30'}`}>
                              <td className="px-4 py-3 text-gray-500">{ri + 1}</td>
                              <td className="px-4 py-3 font-medium text-gray-800">{row.stock_name}</td>
                              <td className="px-4 py-3">{renderMatchBadge(row._matchStatus)}</td>
                              <td className="px-4 py-3">
                                {row._addNew
                                  ? <input type="text" placeholder="New stock name" value={row._newStockName || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _newStockName: e.target.value })} className="border border-blue-300 rounded-lg px-2 py-1 text-xs w-40 focus:outline-none focus:border-blue-500" />
                                  : row._matchStatus === 'matched'
                                    ? <span className="text-green-700 font-medium">{row._matchedName}</span>
                                    : <select value={row._userChoice || ''} onChange={e => updateProcessedRow(sheetKey, row._rowId, { _userChoice: e.target.value })} className="border border-gray-300 rounded-lg px-2 py-1 text-xs w-44 focus:outline-none focus:border-indigo-400">
                                        <option value="">— select match —</option>
                                        {row._candidateMatches?.map(c => <option key={c} value={c}>{c}</option>)}
                                      </select>
                                }
                              </td>
                              <td className="px-4 py-3 text-gray-700">{row.unit}</td>
                              <td className="px-4 py-3 text-gray-700">₹{safeNumber(row.total_amount).toLocaleString()}</td>
                              <td className="px-4 py-3">
                                {row._matchStatus !== 'matched' && (
                                  row._addNew
                                    ? <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: false, _newStockName: '', _userChoice: '' })} className="text-xs text-gray-500 hover:text-gray-700 underline">Cancel</button>
                                    : <button type="button" onClick={() => updateProcessedRow(sheetKey, row._rowId, { _addNew: true, _userChoice: '', _newStockName: row.stock_name })} className="text-xs bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 rounded px-2 py-1 transition">+ Add New</button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex-shrink-0 flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {!allRowsResolved
                  ? <span className="text-amber-600 font-medium">⚠ Some rows need attention (select a match or add new)</span>
                  : <span className="text-green-600 font-medium">✓ All rows resolved — ready to import</span>
                }
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => setExcelUploadStep('setup')} className="border border-gray-300 text-gray-700 rounded-lg px-5 py-2 text-sm font-medium hover:bg-gray-100 transition">← Back</button>
                <button
                  type="button"
                  disabled={!allRowsResolved || excelSubmitLoading}
                  onClick={handleExcelSubmit}
                  className="bg-gradient-to-r from-[#1CAC70] to-[#059669] text-white rounded-lg px-6 py-2 text-sm font-medium hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {excelSubmitLoading ? 'Importing...' : `Import ${Object.values(processedRows).flat().length} Rows`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════════
          ADD STOCK NAME MODAL (Task 2)
      ══════════════════════════════════════════════════════════════════════════ */}
      {showAddStockModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
            <div className="bg-gradient-to-r from-[#3B82F6] to-[#6366F1] px-6 py-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-bold text-white">Add New Stock Name</h3>
                <button onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="text-white/70 hover:text-white text-xl">×</button>
              </div>
              <p className="text-blue-200 text-xs mt-1">This will add the stock to the {addStockModalCategory === 'mutual' ? 'Mutual Funds' : 'Equity'} database</p>
            </div>
            <div className="p-6 flex flex-col gap-4">
              <div>
                <label className="text-sm font-semibold text-gray-700 block mb-1">Stock Name</label>
                <input
                  type="text"
                  placeholder={addStockModalCategory === 'mutual' ? 'e.g. Axis Bluechip Fund' : 'e.g. INFY'}
                  value={pendingNewStockName}
                  onChange={e => setPendingNewStockName(e.target.value)}
                  className="w-full border border-gray-300 p-2.5 rounded-lg text-gray-700 outline-none focus:border-blue-400"
                  autoFocus
                  onKeyDown={e => e.key === 'Enter' && handleAddStockName()}
                />
              </div>
              <div className="bg-blue-50 rounded-lg p-3 text-xs text-blue-700">
                <strong>Adding to:</strong> {addStockModalCategory === 'mutual' ? 'Mutual Funds database (mutualfunds_stock_name)' : 'Equity/Stock database (stocknames)'}
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={() => { setShowAddStockModal(false); setPendingNewStockName(''); }} className="flex-1 border border-gray-300 text-gray-700 rounded-lg py-2 font-medium hover:bg-gray-50 transition">Cancel</button>
                <button type="button" onClick={handleAddStockName} disabled={addStockLoading || !pendingNewStockName.trim()} className="flex-1 bg-gradient-to-r from-[#3B82F6] to-[#6366F1] text-white rounded-lg py-2 font-medium hover:opacity-90 transition disabled:opacity-50">
                  {addStockLoading ? 'Adding...' : 'Add Stock'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Addstock;